// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    useToast,
//    Box,
//    Stepper,
//    Step,
//    StepIndicator,
//    StepStatus,
//    StepIcon,
//    StepNumber,
//    StepTitle,
//    StepDescription,
//    StepSeparator,
//    FormControl,
//    FormLabel,
// } from '@chakra-ui/react';

// import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
// import { getAccount } from '../../../../../redux/actions/account';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//    addDaybook,
//    updateDaybook,
//    getDaybook,
//    getDaybookForMaster,
//    getIssueDaybook,
//    getAllDaybooks,
// } from '../../../../../redux/actions/daybook';
// import {
//    EntryFromType,
//    LINE_ITEM_REACHED,
//    OrderFieldRegion,
//    SupplyTypes,
//    TDS_APPLY_ON,
//    ASK_TO_GENERATE_INVOICE,
// } from '../../../../../utils/dropdownEnum';
// import { TYPE, SUB_TYPE, METHOD_OF_ROUND_LI_TYPE, AUTO_ROUND_OFF_AT_TYPE, PRINTING_SETTING_TYPE } from './DaybookTypes';
// import { WAREHOUSE_TYPE } from '../../../../../../src/variables/company';
// import { renderSwitchControl } from 'utils/DynamicFormData';
// import { renderTextareaControl } from 'utils/DynamicFormData';
// import { getWarehouse } from '../../../../../redux/actions/warehouse';
// // import Select from 'react-select';
// // import { getCompanies } from '../../../../../redux/actions/company';
// import { getGLGroups } from '../../../../../redux/actions/glGroup';
// import { getItemGroup } from '../../../../../redux/actions/itemGroup';
// import '../../../companyProfile/css.css';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { renderDynamicDropdown as renderDynamicDropdown2 } from 'components/ui/DynamicDropdown';
// // import { Type } from 'lucide-react';
// // import { selectOptions } from '@testing-library/user-event/dist/types/utility';
// // import { type } from '@testing-library/user-event/dist/types/utility';
// import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
// import { getShareCompanyOptions } from '../../../../../utils/util';
// import { useGlobal, useUser } from '../../../../../contexts';

// // Validation Schema
// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
//    type: Yup.string().required('Type is required'),
// });

// const steps = [
//    { title: 'Basic', description: 'Set up basic information' },
//    { title: 'Settings', description: 'Configure settings' },
//    { title: 'Printing', description: 'Choose printing options' },
//    { title: 'Others', description: 'Add other details' },
// ];

// const DaybookForm = ({
//    isOpen,
//    onClose,
//    isEditMode = false,
//    demoname,
//    currentRow = null,
//    saveandcontinue = true,
//    type,
//    search,
//    apitype,
//    isAbs = false,
// }) => {
//    const { companyList, userGlobalSettingsData } = useGlobal();
//    const { user } = useUser();
//    const dbName = localStorage.getItem('dbName');
//    const handleCompanyChange = useCallback((selectedOptions) => {
//       setRow((prev) => ({
//          ...prev,
//          compIds: selectedOptions ?? [],
//       }));
//    }, []);
//    const companyOptions = useMemo(() => {
//       return getShareCompanyOptions({ dbName, company: companyList });
//    }, [companyList, dbName]);

//    const lastcompanyOptions = useMemo(
//       () =>
//          companyOptions.map((company) => ({
//             value: company.value,
//             label: company.label,
//             id: company.value,
//             name: company.label,
//          })),
//       [companyOptions],
//    );
//    const [row, setRow] = useState({
//       compIds: [],
//       //1 Basic
//       name: '',
//       type: type ? type : TYPE[1].id, //drop
//       subType: SUB_TYPE[0].id, //drop
//       entryFormType: 1, //drop - ENUM
//       applyGst: false, // Check
//       typeOfSupply: SupplyTypes[1].id, //Drop Enum
//       isAskTypeOfSupply: false,
//       isAllowExchange: false,
//       isOld: false,
//       isAllowNotes: false,
//       isAllowRemark: false,
//       //1 Basic
//       // 2 Settings
//       accountId: null, //DROP
//       itemgroups: [], //Textbox
//       // accountGroup: '', //Textbox
//       wareHouseId: null, //Drop
//       warehouseInId: null, //Drop
//       getTransportDetails: false, // Checkbox
//       getPaymentDet: false, // Check
//       getWorkDetails: false, // Check
//       getOnlinePaymentDetails: false, // Check
//       numOfLineItems: 0, // Textbox num
//       actionIfLIReached: LINE_ITEM_REACHED[1].id, // Drop - enum
//       defaultDate: null, //Text date
//       forceOrderedDate: null, //TExt Date
//       allowZeroAmounts: false, // Check
//       allowEditLIAmount: false, // Check
//       allowZeroQuantities: false, // Check
//       allowIncreaseQty: false, // Check
//       allowChangePrice: false, // Check
//       autoCallOutAdj: false, // Check
//       promptBeforeCallOsa: false, // Check
//       orderFieldRegion: OrderFieldRegion[0].id, //Drop - Enum (header , Line Item)
//       orderdaybookid: null, //Drop - daybook list
//       issueFieldRegion: null, // Drop - Enum (header , Line Item)
//       issuedaybookid: null, //Drop - daybook list
//       challanFieldRegion: OrderFieldRegion[0].id, // Drop - Enum (header , Line Item)
//       challandaybookid: null, //Drop - daybook list
//       getLineDetail: false, // Check
//       allowAutoIssue: false, // Check
//       shouldAskSendSMS: false, // Check
//       methodOfRoundT: METHOD_OF_ROUND_LI_TYPE[2].id, // Dropdown - Enum
//       autoRoundOffAt: AUTO_ROUND_OFF_AT_TYPE[2].id, // Dropdown - Enum
//       methodOfRoundLI: METHOD_OF_ROUND_LI_TYPE[1].id, // Dropdown - Enum
//       issueDaybookId: null, //Drop - daybook list
//       defaultaccountid: null, //Drop - account list
//       // 2 Settings
//       // 3 Printing
//       titleMessage1: '', //Text
//       titleMessage2: '', //Text
//       headerMessage1: '', //Text
//       headerMessage2: '', //Text
//       footerMessage1: '', //Text
//       footerMessage2: '', //Text
//       onlinePrinting: true, //CHeck
//       numOfCopies: 1, //Text num
//       askBeforePrint: false, //check
//       termsNConditions: '', // Textbox multiline 4
//       // 3 Printing
//       //4 others
//       accountNo: '', //Text
//       shortName: '', //Text
//       printName: '', //Text
//       legalName: '', //Text
//       notes: '', //Text
//       remarks: '', //Text

//       updateRateInItem: false, // Check
//       itemWiseLastRate: false, // Check
//       partyItemWiseLastRate: false, // Check
//       reverseCalcOnItemQty: false, // Check
//       accountgroups: [], // Textbox
//       TDSApplyOn: 0, // Drop
//       purchaseDaybookId: null,
//       isGrayPurchase: false,
//       isOtherJobWork: false,
//       isMillIssue: false,
//       isMillReceive: false,
//       sendWhatsApp: false, // Check
//       askToGenerateInvoice: [],
//       askOnlinePaymentDetails: false, // Check
//       requireDiscountLineItem: 1, // Text
//       isAskToAllow: false,
//       askPasswordOnDelete: false,
//       isNotConsiderInStock: false, // Check

//       //4 others
//    });
//    const [errors, setErrors] = useState({});
//    const [activeStep, setActiveStep] = useState(0);
//    const [isLoading, setIsLoading] = useState(false);
//    const [company, setCompany] = useState(null);
//    const applyGST = company?.setting?.applyGST;
//    const enablePurchaseOrder = company?.setting?.enablePurchaseOrder;
//    const enableSaleOrder = company?.setting?.enableSaleOrder;
//    const enableSaleChallan = company?.setting?.enableSaleChallan;
//    const enablePurchaseChallan = company?.setting?.enablePurchaseChallan;
//    const warehouseWishStock = company?.setting?.warehouseWishStock;
//    const toast = useToast();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();
//    const accountList = useSelector((state) => state.account.list);
//    const daybookList = useSelector((state) => state.daybook.issueDaybook);
//    const warehouseList = useSelector((state) => state.warehouse.list);
//    const daybookData = useSelector((state) => state.daybook?.allDaybooks || []);
//    // const companyList = useSelector((state) => state.company.list);
//    const glGroupList = useSelector((state) => state.glGroup.list);
//    const itemGroupList = useSelector((state) => state.itemGroup.list);

//    const shouldSendCompanyidAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
//    const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
//    const shouldSendCompanyidItemGroup = userGlobalSettingsData?.[0]?.askCompany?.itemGroup || false;
//    const shouldSendCompanyidWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;

//    const companyId = localStorage.getItem('companyId');

//    const businessType = localStorage.getItem('businessTypes');
//    const mobile = businessType === 'MOBILE';
//    const Textile = businessType === 'TEXTILE';

//    const clearFormData = () => {
//       setRow({
//          //1 Basic
//          name: '',
//          type: '',
//          subType: 0,
//          entryFormType: 1,
//          applyGst: false,
//          typeOfSupply: null,
//          isAskTypeOfSupply: false,
//          isAllowExchange: false,
//          isOld: false,
//          isAllowNotes: false,
//          isAllowRemark: false,
//          //1 Basic
//          // 2 Settings
//          accountId: null,
//          itemgroups: [],
//          wareHouseId: null,
//          warehouseInId: null,
//          getTransportDetails: false,
//          getPaymentDet: false,
//          getWorkDetails: false,
//          getOnlinePaymentDetails: false,
//          numOfLineItems: 0,
//          actionIfLIReached: 1,
//          defaultDate: null,
//          forceOrderedDate: null,
//          allowZeroAmounts: false,
//          allowEditLIAmount: false,
//          allowZeroQuantities: false,
//          allowIncreaseQty: false,
//          allowChangePrice: false,
//          autoCallOutAdj: false,
//          promptBeforeCallOsa: false,
//          orderFieldRegion: 0,
//          orderdaybookid: null,
//          issueFieldRegion: null,
//          issuedaybookid: null,
//          challanFieldRegion: 0,
//          challandaybookid: null,
//          getLineDetail: false,
//          allowAutoIssue: false,
//          shouldAskSendSMS: false,
//          methodOfRoundT: null,
//          autoRoundOffAt: null,
//          methodOfRoundLI: null,
//          issueDaybookId: '',
//          defaultaccountid: null,
//          // 2 Settings
//          // 3 Printing
//          titleMessage1: '',
//          titleMessage2: '',
//          headerMessage1: '',
//          headerMessage2: '',
//          footerMessage1: '',
//          footerMessage2: '',
//          onlinePrinting: true,
//          numOfCopies: 1,
//          printingSettings: 0,
//          wpSettings: 0,
//          ewayBill: false,
//          ewayInvoice: false,
//          askBeforePrint: false,
//          termsNConditions: '',
//          // 3 Printing
//          //4 others
//          accountNo: '',
//          shortName: '',
//          printName: '',
//          legalName: '',
//          notes: '',
//          remarks: '',
//          gstUniqueID: null,
//          //4 others
//          updateRateInItem: false, // Check
//          itemWiseLastRate: false, // Check
//          partyItemWiseLastRate: false, // Check
//          reverseCalcOnItemQty: false, // Check
//          accountgroups: [], // Textbox
//          TDSApplyOn: 2, // Drop
//          purchaseDaybookId: null,
//          isGrayPurchase: false,
//          isOtherJobWork: false,
//          isMillIssue: false,
//          isMillReceive: false,
//          sendWhatsApp: false, // Check
//          askToGenerateInvoice: [],
//          askOnlinePaymentDetails: false, // Check
//          requireDiscountLineItem: 1, // Text
//          isAskToAllow: false,
//          askPasswordOnDelete: false,
//          isNotConsiderInStock: false, // Check
//       });
//       setErrors({});
//    };

//    useEffect(() => {
//       if (user?.loginhistory?.companyId && !isEditMode) {
//          // Only set if not in edit mode and compIds is empty or doesn't include the user's company
//          setRow((prev) => {
//             if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
//                return {
//                   ...prev,
//                   compIds: [user.loginhistory.companyId],
//                };
//             }
//             return prev;
//          });
//       }
//    }, [user?.loginhistory?.companyId, isEditMode]);

//    useEffect(() => {
//       if (!isEditMode) {
//          clearFormData();
//          setRow((prev) => ({
//             ...prev,
//             compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
//          }));
//       } else if (isEditMode && currentRow) {
//          setRow({
//             //1 Basic
//             name: currentRow.name,
//             type: currentRow.type || type,
//             subType: currentRow.subType,
//             accountId: currentRow.accountId,
//             entryFormType: currentRow.entryFormType,
//             isAskTypeOfSupply: currentRow.isAskTypeOfSupply,
//             isAllowExchange: currentRow.isAllowExchange,
//             isOld: currentRow.isOld,
//             isAllowNotes: currentRow.isAllowNotes,
//             isAllowRemark: currentRow.isAllowRemark,
//             compIds: currentRow?.companyIds || [],
//             //1 Basic
//             // 2 Settings
//             defaultaccountid: currentRow.defaultaccountid || null,
//             // itemgroups: currentRow.itemgroups,

//             itemgroups: (Array.isArray(itemGroupList) ? itemGroupList : [])
//                .map((item) => ({
//                   label: item.name,
//                   value: item.id,
//                }))
//                .filter((item) => Array.isArray(currentRow?.itemgroups) && currentRow.itemgroups.includes(item.value)),

//             accountgroups: glGroupList
//                .map((item) => ({
//                   label: item.name,
//                   value: item.id,
//                }))
//                .filter((item) => currentRow.accountgroups?.includes(item.value)),

//             wareHouseId: currentRow.wareHouseId,
//             warehouseInId: currentRow.warehouseInId,
//             getTransportDetails: currentRow.getTransportDetails,
//             getPaymentDet: currentRow.getPaymentDet,
//             getWorkDetails: currentRow.getWorkDetails,
//             getOnlinePaymentDetails: currentRow.getOnlinePaymentDetails,
//             numOfLineItems: currentRow.numOfLineItems || 0,
//             actionIfLIReached: currentRow.actionIfLIReached,
//             defaultDate: currentRow.defaultDate,
//             // defaultDate: new Date(currentRow.defaultDate)
//             //   .toISOString()
//             //   .split('T')[0],
//             forceOrderedDate: currentRow.forceOrderedDate,
//             // forceOrderedDate: new Date(currentRow.forceOrderedDate)
//             //   .toISOString()
//             //   .split('T')[0],
//             allowZeroAmounts: currentRow.allowZeroAmounts,
//             allowEditLIAmount: currentRow.allowEditLIAmount,
//             allowZeroQuantities: currentRow.allowZeroQuantities,
//             allowIncreaseQty: currentRow.allowIncreaseQty,
//             allowChangePrice: currentRow.allowChangePrice,
//             autoCallOutAdj: currentRow.autoCallOutAdj,
//             promptBeforeCallOsa: currentRow.promptBeforeCallOsa,
//             orderFieldRegion: currentRow.orderFieldRegion,
//             orderdaybookid: currentRow.orderdaybookid,
//             issueFieldRegion: currentRow.issueFieldRegion,
//             issuedaybookid: currentRow.issuedaybookid,
//             challanFieldRegion: currentRow.challanFieldRegion,
//             challandaybookid: Number(currentRow.challandaybookid),
//             getLineDetail: currentRow.getLineDetail,
//             allowAutoIssue: currentRow.allowAutoIssue,
//             shouldAskSendSMS: currentRow.shouldAskSendSMS,
//             methodOfRoundT: currentRow.methodOfRoundT,
//             autoRoundOffAt: currentRow.autoRoundOffAt,
//             methodOfRoundLI: currentRow.methodOfRoundLI,
//             issueDaybookId: currentRow.issueDaybookId,
//             // 2 Settings
//             // 3 Printing
//             titleMessage1: currentRow.titleMessage1,
//             titleMessage2: currentRow.titleMessage2,
//             headerMessage1: currentRow.headerMessage1,
//             headerMessage2: currentRow.headerMessage2,
//             footerMessage1: currentRow.footerMessage1,
//             footerMessage2: currentRow.footerMessage2,
//             onlinePrinting: currentRow.onlinePrinting,
//             numOfCopies: currentRow.numOfCopies,
//             printingSettings: currentRow.printingSettings,
//             wpSettings: currentRow.wpSettings,
//             ewayBill: currentRow.ewayBill,
//             ewayInvoice: currentRow.ewayInvoice,
//             askBeforePrint: currentRow.askBeforePrint,
//             termsNConditions: currentRow.termsNConditions,
//             // 3 Printing
//             // 4 GST Details
//             applyGst: currentRow.applyGst,
//             gstType: currentRow.gstType,
//             gstSubType: currentRow.gstSubType,
//             typeOfSupply: currentRow.typeOfSupply,
//             // 4 GST Details
//             //5 others
//             accountNo: currentRow.accountNo,
//             shortName: currentRow.shortName,
//             printName: currentRow.printName,
//             legalName: currentRow.legalName,
//             notes: currentRow.notes,
//             remarks: currentRow.remarks,
//             gstUniqueID: currentRow.gstUniqueID,
//             updateRateInItem: currentRow.updateRateInItem,
//             itemWiseLastRate: currentRow.itemWiseLastRate,
//             partyItemWiseLastRate: currentRow.partyItemWiseLastRate,
//             reverseCalcOnItemQty: currentRow.reverseCalcOnItemQty,
//             sendWhatsApp: currentRow.sendWhatsApp,
//             TDSApplyOn: currentRow.TDSApplyOn,
//             purchaseDaybookId: currentRow.purchaseDaybookId,
//             isGrayPurchase: currentRow.isGrayPurchase,
//             isOtherJobWork: currentRow.isOtherJobWork,
//             isMillIssue: currentRow.isMillIssue,
//             isMillReceive: currentRow.isMillReceive,
//             askOnlinePaymentDetails: currentRow.askOnlinePaymentDetails,
//             requireDiscountLineItem: currentRow.requireDiscountLineItem,
//             //5 others

//             isAskToAllow: currentRow.isAskToAllow,
//             askPasswordOnDelete: currentRow.askPasswordOnDelete,
//             isNotConsiderInStock: currentRow.isNotConsiderInStock,

//             askToGenerateInvoice: ASK_TO_GENERATE_INVOICE?.map((item) => ({
//                label: item.name,
//                value: item.value,
//             })).filter((item) => currentRow.askToGenerateInvoice?.includes(item.value)),
//          });
//       }
//    }, [isEditMode, currentRow, itemGroupList, glGroupList]);

//    const validateStep = async () => {
//       try {
//          await validationSchema.validate(row, { abortEarly: false });
//          setErrors({});
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       if (field === 'wareHouseId') {
//          setRow((prev) => ({ ...prev, [field]: value === '' ? null : value }));
//          setErrors((prevErrors) => {
//             const newErrors = { ...prevErrors };
//             if (newErrors[field]) {
//                delete newErrors[field];
//             }
//             return newErrors;
//          });
//       } else {
//          setRow((prev) => ({ ...prev, [field]: value }));
//          setErrors((prevErrors) => {
//             const newErrors = { ...prevErrors };
//             if (newErrors[field]) {
//                delete newErrors[field];
//             }
//             return newErrors;
//          });
//       }
//    };

//    const handleSwitchChange = (field) => (event) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: event.target.checked, // Updates boolean value (true/false)
//       }));
//    };

//    const handleSelectChange = (field, value) => {
//       if (field === 'askToGenerateInvoice') {
//          if (value?.map((item) => item.value)?.includes(2)) {
//             setRow((prev) => ({
//                ...prev,
//                [field]: value
//                   ?.map((item) => {
//                      if (item.value === 2) return item;
//                      return null;
//                   })
//                   ?.filter((x) => x !== null),
//             }));
//          } else {
//             setRow((prev) => ({
//                ...prev,
//                [field]: value
//                   ?.map((item) => {
//                      if ([0, 1]?.includes(item.value)) return item;
//                      return null;
//                   })
//                   ?.filter((x) => x !== null),
//             }));
//          }
//       }
//       if (['itemgroups', 'accountgroups']?.includes(field)) {
//          setRow((prev) => ({
//             ...prev,
//             [field]: [value],
//          }));
//       }
//    };

//    const onFormSubmit = async () => {
//       try {
//          setIsLoading(true);
//          const processedData = {
//             ...row,
//             type: Number(row.type),
//             compIds: row.compIds,
//             subType: Number(row.subType),
//             challandaybookid: row.challandaybookid ? row.challandaybookid.toString() : null,
//             // askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item.value) ?? []),
//             askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item) ?? []),
//             // itemgroups: row.itemgroups?.map((item) => Number(item.value) ?? []),
//             itemgroups: row.itemgroups?.map((item) => Number(item) ?? []),
//             // accountgroups: row.accountgroups?.map((item) => Number(item.value) ?? []),
//             accountgroups: row.accountgroups?.map((item) => Number(item) ?? []),
//             isAskTypeOfSupply: row.isAskTypeOfSupply,
//             isAllowExchange: row.isAllowExchange,
//             isOld: row.isOld,
//             isAllowNotes: row.isAllowNotes,
//             isAllowRemark: row.isAllowRemark,
//             isGrayPurchase: row.isGrayPurchase,
//             isOtherJobWork: row.isOtherJobWork,
//             isMillIssue: row.isMillIssue,
//             isMillReceive: row.isMillReceive,
//             issuedaybookid: row.issuedaybookid || null,
//             isAskToAllow: row.isAskToAllow,
//             askPasswordOnDelete: row.askPasswordOnDelete,
//             isNotConsiderInStock: row.isNotConsiderInStock,
//             requireDiscountLineItem: Number(row.requireDiscountLineItem),
//             purchaseDaybookId: row.type === 5 ? row.purchaseDaybookId : null,
//          };

//          if (isEditMode && currentRow?.id) {
//             processedData.id = currentRow.id;
//             dispatch(updateDaybook(processedData));
//          } else {
//             dispatch(addDaybook(processedData));
//          }
//          // await dispatch(
//          //    getDaybook({
//          //       companyId: Number(user?.loginhistory?.companyId),
//          //       page: 1,
//          //       limit: 10,
//          //       sortBy: 'id',
//          //       sortOrder: 'desc',
//          //    }),
//          // );
//          await dispatch(getDaybookForMaster({ companyId: Number(user?.loginhistory?.companyId) }));
//          await dispatch(getDaybook({ companyId: Number(user?.loginhistory?.companyId) }));
//          clearFormData();
//          setActiveStep(0);
//          onClose();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the Daybook.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const onsavecontinue = async () => {
//       try {
//          setIsLoading(true);
//          const processedData = {
//             ...row,
//             type: Number(row.type),
//             subType: Number(row.subType),
//             challandaybookid: row.challandaybookid ? row.challandaybookid.toString() : null,
//             // askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item.value) ?? []),
//             askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item) ?? []),
//             // itemgroups: row.itemgroups?.map((item) => Number(item.value) ?? []),
//             itemgroups: row.itemgroups?.map((item) => Number(item) ?? []),
//             // accountgroups: row.accountgroups?.map((item) => Number(item.value) ?? []),
//             accountgroups: row.accountgroups?.map((item) => Number(item) ?? []),
//             isAskTypeOfSupply: row.isAskTypeOfSupply,
//             isAllowExchange: row.isAllowExchange,
//             isOld: row.isOld,
//             isAllowNotes: row.isAllowNotes,
//             isAllowRemark: row.isAllowRemark,
//             isAskToAllow: row.isAskToAllow,
//             askPasswordOnDelete: row.askPasswordOnDelete,
//             isNotConsiderInStock: row.isNotConsiderInStock,
//             requireDiscountLineItem: Number(row.requireDiscountLineItem),
//          };

//          if (isEditMode && currentRow?.id) {
//             processedData.id = currentRow.id;
//             dispatch(updateDaybook(processedData));
//          } else {
//             dispatch(addDaybook(processedData));
//          }
//          // dispatch(
//          //    getDaybook({
//          //       companyId: user?.loginhistory?.companyId,
//          //       page: 1,
//          //       limit: 10,
//          //       sortBy: 'id',
//          //       sortOrder: 'desc',
//          //    }),
//          // );
//          clearFormData();
//          setActiveStep(0);
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the Daybook.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const handleNext = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          if (activeStep < steps.length - 1) {
//             setActiveStep(activeStep + 1);
//          } else {
//             onFormSubmit();
//          }
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' || // for react-select input
//             activeElement?.isContentEditable;

//          if (isTyping) return; // Don't trigger shortcuts while typing

//          if (isOpen && e.key.toLowerCase() === 's') {
//             // e.preventDefault(); // prevent browser default (e.g. save page)

//             if (e.shiftKey) {
//                handlesavecontinue(); // SHIFT + S
//             } else {
//                handleSave(); // S only
//             }
//          }
//          if (isOpen && e.key.toLowerCase() === 'c') {
//             handleCansel();
//          }
//          if (isOpen && e.key.toLowerCase() === 'n') {
//             handleNext();
//          }
//          if (isOpen && e.key === 'Escape') {
//             e.stopPropagation(); // Prevent event from bubbling to parent
//             onClose();
//          }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateStep]);

//    const handleSave = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onFormSubmit();
//       } else {
//          if (!row.name || row.name.trim() === '') {
//             setActiveStep(0);

//             setTimeout(() => {
//                nameInputRef.current?.focus(); // Focus the name input
//             }, 100);

//             return;
//          } else if (!row.glGroupId || row.glGroupId === '') {
//             setActiveStep(0);

//             setTimeout(() => {
//                typeRef.current?.focus(); // ✅ Focus dropdown
//             }, 100);

//             return;
//          } else if (!row.glGroupId || row.glGroupId === '') {
//             setActiveStep(0);

//             setTimeout(() => {
//                subtypeRef.current?.focus(); // ✅ Focus dropdown
//             }, 100);

//             return;
//          }
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onsavecontinue();
//       } else {
//          if (!row.name || row.name.trim() === '') {
//             setActiveStep(0);

//             setTimeout(() => {
//                nameInputRef.current?.focus(); // Focus the name input
//             }, 100);

//             return;
//          } else if (!row.glGroupId || row.glGroupId === '') {
//             setActiveStep(0);

//             setTimeout(() => {
//                typeRef.current?.focus(); // ✅ Focus dropdown
//             }, 100);

//             return;
//          } else if (!row.glGroupId || row.glGroupId === '') {
//             setActiveStep(0);

//             setTimeout(() => {
//                subtypeRef.current?.focus(); // ✅ Focus dropdown
//             }, 100);

//             return;
//          }
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlePrevious = () => {
//       if (activeStep > 0) {
//          setActiveStep(activeStep - 1);
//       }
//    };

//    useEffect(() => {
//       if (isOpen) {
//          dispatch(
//             getAccount({
//                compId: user?.loginhistory?.companyId,
//                ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
//             }),
//          );
//          dispatch(getWarehouse({ ...(shouldSendCompanyidWarehouse && { companyIds: user?.loginhistory?.companyId }) }));
//          dispatch(
//             getIssueDaybook({
//                type: 19,
//                ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
//                companyId: user?.loginhistory?.companyId,
//             }),
//          );
//          dispatch(
//             getAllDaybooks({
//                companyId: user?.loginhistory?.companyId,
//                type: 11,
//                ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
//             }),
//          );
//          dispatch(getItemGroup({ ...(shouldSendCompanyidItemGroup && { companyIds: user?.loginhistory?.companyId }) }));
//          dispatch(getGLGroups());
//          // dispatch(getCompanies());
//       }
//    }, [dispatch, isOpen]);

//    useEffect(() => {
//       if (companyList.length > 0 && companyId) {
//          const company = companyList.find((company) => company.id.toString() === companyId.toString());
//          setCompany(company);
//       }
//    }, [companyList, companyId]);

//    const itemgroupsoptions = (Array.isArray(itemGroupList) ? itemGroupList : []).map((item) => ({
//       label: item.name,
//       value: item.id,
//       name: item.name,
//       id: item.id,
//    }));

//    const accountgroupsoptions = (Array.isArray(glGroupList) ? glGroupList : []).map((item) => ({
//       label: item.name,
//       value: item.id,
//       name: item.name,
//       id: item.id,
//    }));
//    const ASK_TO_GENERATE_INVOICE_option = ASK_TO_GENERATE_INVOICE?.map((item) => ({
//       label: item.name,
//       value: item.id,
//       name: item.name,
//       id: item.id,
//    }));

//    // options={glGroupList?.map((item) => ({
//    //    label: item.name,
//    //    value: item.id,
//    // }))}

//    const nameInputRef = useRef();
//    const typeRef = useRef();
//    const subtypeRef = useRef();
//    const entryFormTypeRef = useRef();
//    const typeOfSupplyRef = useRef();
//    const applyGstRef = useRef();
//    const accountRef = useRef();
//    const isAskTypeOfSupplyRef = useRef();
//    const companyRef = useRef();
//    const isAllowExchangeRef = useRef();
//    const savefinish = useRef();
//    const accountgroupsRef = useRef();
//    const defaultaccountRef = useRef();
//    const itemgroupsRef = useRef();
//    const defaultDateRef = useRef();
//    const actionIfLIReachedRef = useRef();
//    const getWorkDetailsRef = useRef();
//    const getOnlinePaymentDetailsRef = useRef();
//    const numOfLineItemsRef = useRef();
//    const getPaymentDetRef = useRef();
//    const getTransportDetailsRef = useRef();
//    const wareHouseRef = useRef();
//    const wareHouseInRef = useRef();
//    const shouldAskSendSMSRef = useRef();
//    const challandaybookRef = useRef();
//    const getLineDetailRef = useRef();
//    const allowAutoIssueRef = useRef();
//    const challanFieldRegionRef = useRef();
//    const issuedaybookRef = useRef();
//    const issueFieldRegionRef = useRef();
//    const promptBeforeCallOsaRef = useRef();
//    const orderFieldRegionRef = useRef();
//    const orderdaybookRef = useRef();
//    const allowIncreaseQtyRef = useRef();
//    const allowChangePriceRef = useRef();
//    const autoCallOutAdjRef = useRef();
//    const allowZeroAmountsRef = useRef();
//    const allowEditLIAmountRef = useRef();
//    const allowZeroQuantitiesRef = useRef();
//    const forceOrderedDateRef = useRef();
//    const isAskToAllowRef = useRef();
//    const askPasswordOnDeleteRef = useRef();
//    const isNotConsiderInStockRef = useRef();
//    const methodOfRoundLIRef = useRef();
//    const autoRoundOffAtRef = useRef();
//    const requireDiscountLineItemRef = useRef();
//    const methodOfRoundTRef = useRef();
//    const titleMessage1Ref = useRef();
//    const footerMessage1Ref = useRef();
//    const headerMessage2Ref = useRef();
//    const headerMessage1Ref = useRef();
//    const titleMessage2Ref = useRef();
//    const termsNConditionsRef = useRef();
//    const wpSettingsRef = useRef();
//    const sendWhatsAppRef = useRef();
//    const ewayInvoiceRef = useRef();
//    const printingSettingsRef = useRef();
//    const ewayBillRef = useRef();
//    const onlinePrintingRef = useRef();
//    const numOfCopiesRef = useRef();
//    const askBeforePrintRef = useRef();
//    const footerMessage2Ref = useRef();
//    const isOldRef = useRef();
//    const isAllowNotesRef = useRef();
//    const isAllowRemarkRef = useRef();
//    const askOnlinePaymentDetailsRef = useRef();
//    const reverseCalcOnItemQtyRef = useRef();
//    const TDSApplyOnRef = useRef();
//    const purcherDaybookRef = useRef();
//    const isGrayPurchaseRef = useRef();
//    const isMillIssueRef = useRef();
//    const isMillReceiveRef = useRef();
//    const isOtherJobWorkRef = useRef();
//    const askToGenerateInvoiceRef = useRef();
//    const updateRateInItemRef = useRef();
//    const itemWiseLastRateRef = useRef();
//    const partyItemWiseLastRateRef = useRef();
//    const remarksRef = useRef();
//    const legalNameRef = useRef();
//    const notesRef = useRef();
//    const accountNoRef = useRef();
//    const shortNameRef = useRef();
//    const printNameRef = useRef();
//    // const notesRef = useRef();

//    const handleCansel = async () => {
//       onClose();
//       if (!isEditMode) {
//          clearFormData();
//       }
//       await dispatch(getAllDaybooks({ companyId: Number(user?.loginhistory?.companyId) }));
//    };

//    useEffect(() => {
//       if (demoname && row.name === '') {
//          setRow((prev) => ({ ...prev, name: demoname }));
//       }
//       demoname = '';
//    }, [demoname, row.name]);

//    useEffect(() => {
//       setTimeout(() => {
//          nameInputRef.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isOpen]);

//    useEffect(() => {
//       if (activeStep === 1) {
//          setTimeout(() => {
//             defaultaccountRef.current?.focus();
//          }, 100); // small delay sometimes helps
//       }
//    }, [activeStep]);

//    useEffect(() => {
//       if (activeStep === 2) {
//          setTimeout(() => {
//             titleMessage1Ref.current?.focus();
//          }, 100); // small delay sometimes helps
//       }
//    }, [activeStep]);

//    useEffect(() => {
//       if (activeStep === 3) {
//          setTimeout(() => {
//             accountNoRef.current?.focus();
//          }, 100); // small delay sometimes helps
//       }
//    }, [activeStep]);

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === 'Escape') {
//             e.preventDefault();
//             handleCansel();
//          }
//       };

//       document.addEventListener('keydown', handleEsc);
//       return () => {
//          document.removeEventListener('keydown', handleEsc);
//       };
//    }, [handleCansel]);

//    const handleFocusMove = (e, nextRef, prevRef) => {
//       if (e.key === 'Tab' || e.key === 'Enter') {
//          e.preventDefault(); // Prevent default tab/enter behavior
//          if (e.shiftKey) {
//             // Move to previous input if Shift is pressed
//             prevRef?.current?.focus();
//          } else {
//             // Move to next input
//             nextRef?.current?.focus();
//          }
//       }
//    };

//    return (
//       <Modal isOpen={isOpen} onClose={handleCansel} size="6xl" scrollBehavior="inside" overflowY="scroll">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '20%', md: '10%', xl: '8%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
//                {isEditMode ? 'Edit Daybook' : 'Add New Daybook'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                <Grid h="auto" templateColumns="repeat(5, 1fr)" gap={4} display="block">
//                   <GridItem rowSpan={2} colSpan={1}>
//                      <Stepper
//                         index={activeStep}
//                         orientation="horizontal"
//                         colorScheme="green"
//                         border="1px solid"
//                         borderRadius={5}
//                         px={{ base: 2, md: 5, xl: 5 }}
//                         py={{ base: 3, md: 3, xl: 3 }}
//                         mb={{ base: 3, md: 5, xl: 5 }}
//                         overflowX="auto">
//                         {steps.map((step, index) => (
//                            <Step key={index}>
//                               <Box
//                                  flexShrink="1"
//                                  cursor="pointer"
//                                  onClick={() => setActiveStep(index)} // Set active step on click
//                                  justifyItems="center">
//                                  <StepIndicator
//                                     width={{ base: '20px', xl: '30px' }}
//                                     height={{ base: '20px', xl: '30px' }}>
//                                     <StepStatus
//                                        complete={<StepIcon />}
//                                        incomplete={<StepNumber fontSize={{ base: '12px', md: '14px', xl: '16px' }} />}
//                                        active={<StepNumber fontSize={{ base: '12px', md: '14px', xl: '16px' }} />}
//                                     />
//                                  </StepIndicator>
//                                  <StepTitle fontSize={{ base: '0px', md: '14px', xl: '14px' }} textAlign="center">
//                                     {step.title}
//                                  </StepTitle>
//                                  {/* <StepDescription style={{ marginLeft: 22 }}>
//                         {step.description}
//                       </StepDescription> */}
//                               </Box>
//                               <StepSeparator />
//                            </Step>
//                         ))}
//                      </Stepper>
//                   </GridItem>
//                   <GridItem colSpan={4}>
//                      <Grid
//                         templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
//                         gap={2}>
//                         {activeStep === 0 && (
//                            <>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'name',
//                                     'Name',
//                                     {
//                                        value: row.name,
//                                        onChange: (e) => handleInputChange('name', e.target.value),
//                                        disabled: isEditMode && isAbs,
//                                        ref: nameInputRef,
//                                        // onKeyDown: (e) => {
//                                        //    if (e.key === 'Enter' || e.key === 'Tab') {
//                                        //       e.preventDefault();
//                                        //       typeRef.current?.focus();
//                                        //    }
//                                        // },
//                                        onKeyDown: (e) => handleFocusMove(e, typeRef, null),
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     true,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderDynamicDropdown(
//                                     'type',
//                                     'Type',
//                                     TYPE,
//                                     {
//                                        value: row.type || type,
//                                        onChange: (value) => {
//                                           const selectedOption = TYPE?.find(
//                                              (item) => item.value === value || item.id === value,
//                                           );
//                                           handleInputChange('type', value);
//                                           if (selectedOption) {
//                                              handleInputChange('typeName', selectedOption.name || selectedOption.label);
//                                           }
//                                        },
//                                        ref: typeRef,
//                                        nextRef: Textile
//                                           ? subtypeRef
//                                           : !['Cash', 'Bank', 'Debit Note', 'Credit Note', 'Journal Voucher'].includes(row.typeName)
//                                              ? entryFormTypeRef
//                                              : company && company?.gstRegNo
//                                                 ? applyGstRef
//                                                 : accountRef,
//                                     },
//                                     errors,
//                                     textColor,
//                                     true,
//                                     'Select Type',
//                                  )}
//                               </GridItem>
//                               {Textile && (
//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'subType',
//                                        'Sub Type',
//                                        SUB_TYPE,
//                                        {
//                                           value: row.subType,
//                                           onChange: (value) => {
//                                              handleInputChange('subType', value);
//                                           },
//                                           ref: subtypeRef,
//                                           nextRef: !['Cash', 'Bank', 'Debit Note', 'Credit Note', 'Journal Voucher'].includes(row.typeName)
//                                              ? entryFormTypeRef
//                                              : company && company?.gstRegNo
//                                                 ? applyGstRef
//                                                 : accountRef,
//                                        },
//                                        errors,
//                                        textColor,
//                                        true,
//                                        'Select Sub type',
//                                     )}
//                                  </GridItem>
//                               )}
//                               {!['Cash', 'Bank', 'Debit Note', 'Credit Note', 'Journal Voucher'].includes(
//                                  row.typeName,
//                               ) && (
//                                     <>
//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'entryFormType',
//                                              'Form Type',
//                                              EntryFromType,
//                                              {
//                                                 value: row.entryFormType || EntryFromType[0].id,
//                                                 onChange: (value) => handleInputChange('entryFormType', value),
//                                                 ref: entryFormTypeRef,
//                                                 nextRef: typeOfSupplyRef,
//                                              },
//                                              errors,
//                                              textColor,
//                                              false,
//                                              'Select Form Type',
//                                           )}
//                                        </GridItem>
//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'typeOfSupply',
//                                              'Supply Type',
//                                              SupplyTypes,
//                                              {
//                                                 value: row.typeOfSupply || SupplyTypes[1].id,
//                                                 onChange: (value) => handleInputChange('typeOfSupply', value),
//                                                 ref: typeOfSupplyRef,
//                                                 nextRef: company && company?.gstRegNo ? applyGstRef : accountRef,
//                                              },
//                                              errors,
//                                              textColor,
//                                              false,
//                                              'Select Type of Supply',
//                                           )}
//                                        </GridItem>
//                                     </>
//                                  )}
//                               {company && company?.gstRegNo && (
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'applyGst',
//                                        'Apply GST',
//                                        {
//                                           isChecked: row.applyGst,
//                                           onChange: handleSwitchChange('applyGst'),
//                                           ref: applyGstRef,
//                                           // onKeyDown: (e) => {
//                                           //    if (e.key === 'Enter' || e.key === 'Tab') {
//                                           //       e.preventDefault();
//                                           //       accountRef.current?.focus();
//                                           //    }
//                                           // },
//                                           onKeyDown: (e) => handleFocusMove(e, accountRef, !['Cash', 'Bank', 'Debit Note', 'Credit Note', 'Journal Voucher'].includes(row.typeName) ? typeOfSupplyRef : Textile ? subtypeRef : typeRef),
//                                        },
//                                        errors,
//                                        textColor,
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {renderDynamicDropdown(
//                                     'accountId',
//                                     'Account',
//                                     accountList,
//                                     {
//                                        value: row.accountId,
//                                        onChange: (value) => handleInputChange('accountId', value),
//                                        showCustomNoOptions: true,
//                                        openfrom: 'account',
//                                        ref: accountRef,
//                                        // onKeyDown: (e) => {
//                                        //    if (e.key === 'Enter' || e.key === 'Tab') {
//                                        //       e.preventDefault();
//                                        //       isAskTypeOfSupplyRef.current?.focus();
//                                        //    }
//                                        // },
//                                        onKeyDown: (e) => handleFocusMove(e, isAskTypeOfSupplyRef, company && company?.gstRegNo ? applyGstRef : !['Cash', 'Bank', 'Debit Note', 'Credit Note', 'Journal Voucher'].includes(row.typeName) ? entryFormTypeRef : Textile ? subtypeRef : typeRef),
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Account',
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'isAskTypeOfSupply',
//                                     'Ask Type Of Supply',
//                                     {
//                                        isChecked: row.isAskTypeOfSupply,
//                                        onChange: handleSwitchChange('isAskTypeOfSupply'),
//                                        ref: isAskTypeOfSupplyRef,
//                                        // onKeyDown: (e) => {
//                                        //    if (e.key === 'Enter' || e.key === 'Tab') {
//                                        //       e.preventDefault();
//                                        //       isAllowExchangeRef.current?.focus();
//                                        //    }
//                                        // },
//                                        onKeyDown: (e) => handleFocusMove(e, shouldSendCompanyidDaybook ? companyRef : mobile ? isAllowExchangeRef : savefinish, accountRef),
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               {shouldSendCompanyidDaybook && (
//                                  <GridItem className="seperator-width">
//                                     {renderDynamicUiDropdown(
//                                        'company',
//                                        'Company',
//                                        lastcompanyOptions,
//                                        {
//                                           value: row.compIds,
//                                           onChange: handleCompanyChange,
//                                           ref: companyRef,
//                                           nextRef: mobile ? isAllowExchangeRef : savefinish,
//                                           onKeyDown: (e) => handleFocusMove(e, mobile ? isAllowExchangeRef : savefinish, isAskTypeOfSupplyRef),
//                                        },
//                                        {},
//                                        textColor,
//                                        false,
//                                        'Select company',
//                                        true,
//                                        undefined,
//                                        true,
//                                     )}
//                                  </GridItem>
//                               )}
//                               {mobile && (
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'isAllowExchange ',
//                                        'Ask Allow Of Exchange ',
//                                        {
//                                           isChecked: row.isAllowExchange,
//                                           onChange: handleSwitchChange('isAllowExchange'),
//                                           ref: isAllowExchangeRef,
//                                           // onKeyDown: (e) => {
//                                           //    if (e.key === 'Enter' || e.key === 'Tab') {
//                                           //       e.preventDefault();
//                                           //       savefinish.current?.focus();
//                                           //    }
//                                           // },
//                                           onKeyDown: (e) => handleFocusMove(e, savefinish, shouldSendCompanyidDaybook ? companyRef : isAskTypeOfSupplyRef),
//                                        },
//                                        errors,
//                                        textColor,
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>
//                               )}
//                            </>
//                         )}
//                         {activeStep === 1 && (
//                            <>
//                               <GridItem className="seperator-width">
//                                  {renderDynamicDropdown(
//                                     'defaultaccountid',
//                                     'Default Account',
//                                     accountList,
//                                     {
//                                        value: row.defaultaccountid,
//                                        onChange: (value) => handleInputChange('defaultaccountid', value),
//                                        ref: defaultaccountRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              itemgroupsRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Default Account',
//                                  )}
//                               </GridItem>
//                               <GridItem>
//                                  {renderDynamicDropdown(
//                                     'itemgroups',
//                                     'Item Groups',
//                                     itemgroupsoptions,
//                                     {
//                                        value: row.itemgroups,
//                                        onChange: (e) => handleSelectChange('itemgroups', e),
//                                        showCustomNoOptions: true,
//                                        openfrom: 'itemgroups',
//                                        ref: itemgroupsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              accountgroupsRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Default Account',
//                                  )}
//                               </GridItem>

//                               {/* <FormControl display="flex" className="seperator-width">
//                                  <FormLabel margin={0} width="50%">
//                                     Item Groups
//                                  </FormLabel>
//                                  <Select
//                                     placeholder="Select Item Groups"
//                                     name="itemgroups"
//                                     options={(Array.isArray(itemGroupList) ? itemGroupList : []).map((item) => ({
//                                        label: item.name,
//                                        value: item.id,
//                                     }))}
//                                     value={row.itemgroups}
//                                     onChange={(e) => handleSelectChange('itemgroups', e)}
//                                     isMulti
//                                  />
//                               </FormControl> */}

//                               <GridItem>
//                                  {renderDynamicDropdown(
//                                     'accountgroups',
//                                     'Account Groups',
//                                     accountgroupsoptions,
//                                     {
//                                        value: row.accountgroups,
//                                        onChange: (e) => handleSelectChange('accountgroups', e),
//                                        showCustomNoOptions: true,
//                                        openfrom: 'ledger',
//                                        ref: accountgroupsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              wareHouseRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Default Account',
//                                  )}
//                               </GridItem>

//                               {/* <FormControl display="flex" width="95%">
//                                  <FormLabel margin={0} width="60%">
//                                     Account Groups
//                                  </FormLabel>
//                                  <Select
//                                     placeholder="Select Account Groups"
//                                     name="accountgroups"
//                                     options={glGroupList?.map((item) => ({
//                                        label: item.name,
//                                        value: item.id,
//                                     }))}
//                                     value={row.accountgroups}
//                                     onChange={(e) => handleSelectChange('accountgroups', e)}
//                                     isMulti
//                                  />
//                               </FormControl> */}

//                               {warehouseWishStock && (
//                                  <>
//                                     <GridItem className="seperator-width">
//                                        {/* change */}
//                                        {renderDynamicDropdown(
//                                           'wareHouseId',
//                                           'Ware House',
//                                           warehouseList,
//                                           {
//                                              value: row.wareHouseId,
//                                              onChange: (value) => handleInputChange('wareHouseId', value),
//                                              showCustomNoOptions: true,
//                                              openfrom: 'wareHouse',
//                                              ref: wareHouseRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    wareHouseInRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           'Select Ware House',
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {/* change */}
//                                        {renderDynamicDropdown(
//                                           'warehouseInId',
//                                           'Ware House in',
//                                           WAREHOUSE_TYPE,
//                                           {
//                                              value: row.warehouseInId,
//                                              onChange: (value) => handleInputChange('warehouseInId', value),
//                                              ref: wareHouseInRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    getTransportDetailsRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           'Select Ware House',
//                                        )}
//                                     </GridItem>
//                                  </>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'getTransportDetails',
//                                     'Transport Details',
//                                     {
//                                        isChecked: row.getTransportDetails,
//                                        onChange: handleSwitchChange('getTransportDetails'),
//                                        ref: getTransportDetailsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              getPaymentDetRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               {/* <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'getPaymentDet',
//                                     'Get Payment Details',
//                                     {
//                                        isChecked: row.getPaymentDet,
//                                        onChange: handleSwitchChange('getPaymentDet'),
//                                        ref: getPaymentDetRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              getWorkDetailsRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem> */}
//                               {Textile && (
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'getWorkDetails',
//                                        'Get Work Details',
//                                        {
//                                           isChecked: row.getWorkDetails,
//                                           onChange: handleSwitchChange('getWorkDetails'),
//                                           ref: getWorkDetailsRef,
//                                           onKeyDown: (e) => {
//                                              if (e.key === 'Enter' || e.key === 'Tab') {
//                                                 e.preventDefault();
//                                                 getOnlinePaymentDetailsRef.current?.focus();
//                                              }
//                                           },
//                                        },
//                                        errors,
//                                        textColor,
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'getOnlinePaymentDetails',
//                                     'Get Online Payment Details',
//                                     {
//                                        isChecked: row.getOnlinePaymentDetails,
//                                        onChange: handleSwitchChange('getOnlinePaymentDetails'),
//                                        ref: getOnlinePaymentDetailsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              numOfLineItemsRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               {/* <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'numOfLineItems',
//                                     'Max. Line Items',
//                                     {
//                                        value: row.numOfLineItems,
//                                        onChange: (e) =>
//                                           handleInputChange('numOfLineItems', parseInt(e.target.value) || 0),
//                                        ref: numOfLineItemsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              actionIfLIReachedRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'number',
//                                     false,
//                                  )}
//                               </GridItem> */}
//                               <GridItem className="seperator-width">
//                                  {/* Block Done*/}
//                                  {renderDynamicDropdown(
//                                     'actionIfLIReached',
//                                     'Action If LI Reached',
//                                     LINE_ITEM_REACHED,
//                                     {
//                                        value: row.actionIfLIReached,
//                                        onChange: (value) => handleInputChange('actionIfLIReached', value),
//                                        ref: actionIfLIReachedRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              defaultDateRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Action If LI Reached',
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'defaultDate',
//                                     'Default Date',
//                                     {
//                                        value: row.defaultDate,
//                                        onChange: (e) => handleInputChange('defaultDate', e.target.value),
//                                        ref: defaultDateRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              forceOrderedDateRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'date',
//                                     false,
//                                  )}
//                               </GridItem>
//                               {/* <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'forceOrderedDate',
//                                     'Force Ordered Date',
//                                     {
//                                        value: row.forceOrderedDate,
//                                        onChange: (e) => handleInputChange('forceOrderedDate', e.target.value),
//                                        ref: forceOrderedDateRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              allowZeroAmountsRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'date',
//                                     false,
//                                  )}
//                               </GridItem> */}
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'allowZeroAmounts',
//                                     'Allow Zero Amounts',
//                                     {
//                                        isChecked: row.allowZeroAmounts,
//                                        onChange: handleSwitchChange('allowZeroAmounts'),
//                                        ref: allowZeroAmountsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              allowEditLIAmountRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'allowEditLIAmount',
//                                     'Allow Edit LI Amounts',
//                                     {
//                                        isChecked: row.allowEditLIAmount,
//                                        onChange: handleSwitchChange('allowEditLIAmount'),
//                                        ref: allowEditLIAmountRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              allowZeroQuantitiesRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'allowZeroQuantities',
//                                     'Allow Zero Quantity',
//                                     {
//                                        isChecked: row.allowZeroQuantities,
//                                        onChange: handleSwitchChange('allowZeroQuantities'),
//                                        ref: allowZeroQuantitiesRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              allowIncreaseQtyRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               {enablePurchaseOrder || enableSaleOrder ? (
//                                  <>
//                                     {/* Show "Allow Increase Qty" only when ORDER is ON */}
//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'allowIncreaseQty',
//                                           'Allow Increase Qty',
//                                           {
//                                              isChecked: row.allowIncreaseQty,
//                                              onChange: handleSwitchChange('allowIncreaseQty'),
//                                              ref: allowIncreaseQtyRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    allowChangePriceRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>

//                                     {/* Show "Allow Change Price" when ORDER is ON */}
//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'allowChangePrice',
//                                           'Allow Change Price',
//                                           {
//                                              isChecked: row.allowChangePrice,
//                                              onChange: handleSwitchChange('allowChangePrice'),
//                                              ref: allowChangePriceRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    autoCallOutAdjRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>
//                                  </>
//                               ) : enablePurchaseChallan || enableSaleChallan ? (
//                                  <>
//                                     {/* Show only "Allow Change Price" when CHALLAN is ON */}
//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'allowChangePrice',
//                                           'Allow Change Price',
//                                           {
//                                              isChecked: row.allowChangePrice,
//                                              onChange: handleSwitchChange('allowChangePrice'),
//                                              ref: allowChangePriceRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    autoCallOutAdjRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>
//                                  </>
//                               ) : null}
//                               {/* <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'autoCallOutAdj',
//                                     'Call Out Adj.',
//                                     {
//                                        isChecked: row.autoCallOutAdj,
//                                        onChange: handleSwitchChange('autoCallOutAdj'),
//                                        ref: autoCallOutAdjRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              promptBeforeCallOsaRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'promptBeforeCallOsa',
//                                     'Prompt Before Call Os Adj.',
//                                     {
//                                        isChecked: row.promptBeforeCallOsa,
//                                        onChange: handleSwitchChange('promptBeforeCallOsa'),
//                                        ref: promptBeforeCallOsaRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              orderFieldRegionRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem> */}
//                               {(enablePurchaseOrder || enableSaleOrder) && (
//                                  <>
//                                     <GridItem className="seperator-width">
//                                        {/* Header Done*/}
//                                        {renderDynamicDropdown(
//                                           'orderFieldRegion',
//                                           'Order Field Region',
//                                           OrderFieldRegion,
//                                           {
//                                              value: row.orderFieldRegion,
//                                              onChange: (value) => handleInputChange('orderFieldRegion', value),
//                                              ref: orderFieldRegionRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    orderdaybookRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           'Select Order Field Region',
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {renderDynamicDropdown(
//                                           'orderdaybookid',
//                                           'Order Daybook',
//                                           daybookList,
//                                           {
//                                              value: row.orderdaybookid,
//                                              onChange: (value) => handleInputChange('orderdaybookid', value),
//                                              showCustomNoOptions: true,
//                                              openfrom: 'ledger',
//                                              ref: orderdaybookRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    issueFieldRegionRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           'Select Order Daybook',
//                                        )}
//                                     </GridItem>
//                                  </>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {/* Header */}
//                                  {renderDynamicDropdown(
//                                     'issueFieldRegion',
//                                     'Issue Field Region',
//                                     OrderFieldRegion,
//                                     {
//                                        value: row.issueFieldRegion,
//                                        onChange: (value) => handleInputChange('issueFieldRegion', value),
//                                        ref: issueFieldRegionRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              issuedaybookRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Issue Field Region',
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderDynamicDropdown(
//                                     'issuedaybookid',
//                                     'Issue Daybook',
//                                     daybookList,
//                                     {
//                                        value: row.issuedaybookid,
//                                        onChange: (value) => handleInputChange('issuedaybookid', value),
//                                        ref: issuedaybookRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              challanFieldRegionRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Issue Daybook',
//                                  )}
//                               </GridItem>
//                               {(enableSaleChallan || enablePurchaseChallan) && (
//                                  <>
//                                     <GridItem className="seperator-width">
//                                        {/* Header */}
//                                        {renderDynamicDropdown(
//                                           'challanFieldRegion',
//                                           'Challan Field Region',
//                                           OrderFieldRegion,
//                                           {
//                                              value: row.challanFieldRegion,
//                                              onChange: (value) => handleInputChange('challanFieldRegion', value),
//                                              ref: challanFieldRegionRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    challandaybookRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           'Select Challan Field Region',
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {renderDynamicDropdown(
//                                           'challandaybookid',
//                                           'Challan Daybook',
//                                           daybookList,
//                                           {
//                                              value: row.challandaybookid,
//                                              onChange: (value) => handleInputChange('challandaybookid', value),
//                                              ref: challandaybookRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    getLineDetailRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           'Select Challan Daybook',
//                                        )}
//                                     </GridItem>
//                                  </>
//                               )}
//                               {Textile && (
//                                  <>
//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'getLineDetail',
//                                           'Get Line Detail',
//                                           {
//                                              isChecked: row.getLineDetail,
//                                              onChange: handleSwitchChange('getLineDetail'),
//                                              ref: getLineDetailRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    allowAutoIssueRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>

//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'allowAutoIssue',
//                                           'Allow Auto Issue',
//                                           {
//                                              isChecked: row.allowAutoIssue,
//                                              onChange: handleSwitchChange('allowAutoIssue'),
//                                              ref: allowAutoIssueRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    shouldAskSendSMSRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>
//                                  </>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'shouldAskSendSMS',
//                                     'Should Ask Send SMS',
//                                     {
//                                        isChecked: row.shouldAskSendSMS,
//                                        onChange: handleSwitchChange('shouldAskSendSMS'),
//                                        ref: shouldAskSendSMSRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              methodOfRoundTRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {/* Normal Done */}
//                                  {renderDynamicDropdown(
//                                     'methodOfRoundT',
//                                     'Round Off (T)',
//                                     METHOD_OF_ROUND_LI_TYPE,
//                                     {
//                                        value: row.methodOfRoundT,
//                                        onChange: (value) => handleInputChange('methodOfRoundT', value),
//                                        ref: methodOfRoundTRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              methodOfRoundLIRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Method of Round T',
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {/* None Done */}
//                                  {renderDynamicDropdown(
//                                     'methodOfRoundLI',
//                                     'Round Off (LI)',
//                                     METHOD_OF_ROUND_LI_TYPE,
//                                     {
//                                        value: row.methodOfRoundLI || METHOD_OF_ROUND_LI_TYPE[1].id,
//                                        onChange: (value) => handleInputChange('methodOfRoundLI', value),
//                                        ref: methodOfRoundLIRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              autoRoundOffAtRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Method of Round LI',
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {/* Total Done*/}
//                                  {renderDynamicDropdown(
//                                     'autoRoundOffAt',
//                                     'Round off At',
//                                     AUTO_ROUND_OFF_AT_TYPE,
//                                     {
//                                        value: row.autoRoundOffAt,
//                                        onChange: (value) => handleInputChange('autoRoundOffAt', value),
//                                        ref: autoRoundOffAtRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              requireDiscountLineItemRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Auto of Round T',
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'requireDiscountLineItem',
//                                     'Require Discount Line Item',
//                                     {
//                                        value: row.requireDiscountLineItem,
//                                        onChange: (e) => handleInputChange('requireDiscountLineItem', e.target.value),
//                                        ref: requireDiscountLineItemRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              isNotConsiderInStockRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'number',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'isNotConsiderInStock',
//                                     'Is Not Consider In Stock',
//                                     {
//                                        isChecked: row.isNotConsiderInStock,
//                                        onChange: handleSwitchChange('isNotConsiderInStock'),
//                                        ref: isNotConsiderInStockRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              isAskToAllowRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               {mobile && (
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'isAskToAllow',
//                                        'Ask Upload Document',
//                                        {
//                                           isChecked: row.isAskToAllow,
//                                           onChange: handleSwitchChange('isAskToAllow'),
//                                           ref: isAskToAllowRef,
//                                           onKeyDown: (e) => {
//                                              if (e.key === 'Enter' || e.key === 'Tab') {
//                                                 e.preventDefault();
//                                                 askPasswordOnDeleteRef.current?.focus();
//                                              }
//                                           },
//                                        },
//                                        errors,
//                                        textColor,
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'askPasswordOnDelete',
//                                     'Ask Password On Delete',
//                                     {
//                                        isChecked: row.askPasswordOnDelete,
//                                        onChange: handleSwitchChange('askPasswordOnDelete'),
//                                        ref: askPasswordOnDeleteRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              savefinish.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                            </>
//                         )}

//                         {activeStep === 2 && (
//                            <>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'titleMessage1',
//                                     'Title Message 1',
//                                     {
//                                        value: row.titleMessage1,
//                                        onChange: (e) => handleInputChange('titleMessage1', e.target.value),
//                                        ref: titleMessage1Ref,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              titleMessage2Ref.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'titleMessage2',
//                                     'Title Message 2',
//                                     {
//                                        value: row.titleMessage2,
//                                        onChange: (e) => handleInputChange('titleMessage2', e.target.value),
//                                        ref: titleMessage2Ref,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              headerMessage1Ref.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'headerMessage1',
//                                     'Header Message 1',
//                                     {
//                                        value: row.headerMessage1,
//                                        onChange: (e) => handleInputChange('headerMessage1', e.target.value),
//                                        ref: headerMessage1Ref,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              headerMessage2Ref.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'headerMessage2',
//                                     'Header Message 2',
//                                     {
//                                        value: row.headerMessage2,
//                                        onChange: (e) => handleInputChange('headerMessage2', e.target.value),
//                                        ref: headerMessage2Ref,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              footerMessage1Ref.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'footerMessage1',
//                                     'Footer Message 1',
//                                     {
//                                        value: row.footerMessage1,
//                                        onChange: (e) => handleInputChange('footerMessage1', e.target.value),
//                                        ref: footerMessage1Ref,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              footerMessage2Ref.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'footerMessage2',
//                                     'Footer Message 2',
//                                     {
//                                        value: row.footerMessage2,
//                                        onChange: (e) => handleInputChange('footerMessage2', e.target.value),
//                                        ref: footerMessage2Ref,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              askBeforePrintRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'askBeforePrint',
//                                     'Ask Before Print',
//                                     {
//                                        isChecked: row.askBeforePrint,
//                                        onChange: handleSwitchChange('askBeforePrint'),
//                                        ref: askBeforePrintRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              numOfCopiesRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {/* 1 Done*/}
//                                  {DynamicInput(
//                                     'numOfCopies',
//                                     'No. Of Copies',
//                                     {
//                                        value: row.numOfCopies || 1,
//                                        onChange: (e) => handleInputChange('numOfCopies', e.target.value),
//                                        ref: numOfCopiesRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              onlinePrintingRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'number',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {/* True */}
//                                  {renderSwitchControl(
//                                     'onlinePrinting',
//                                     'Online Printing',
//                                     {
//                                        isChecked: row.onlinePrinting,
//                                        onChange: handleSwitchChange('onlinePrinting'),
//                                        ref: onlinePrintingRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              ewayBillRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               {applyGST && (
//                                  <>
//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'ewayBill',
//                                           'E-way Bill',
//                                           {
//                                              isChecked: row.ewayBill,
//                                              onChange: handleSwitchChange('ewayBill'),
//                                              ref: ewayBillRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    ewayInvoiceRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'ewayInvoice',
//                                           'E-Invoice',
//                                           {
//                                              isChecked: row.ewayInvoice,
//                                              onChange: handleSwitchChange('ewayInvoice'),
//                                              ref: ewayInvoiceRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    printingSettingsRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>
//                                  </>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {/* Printing Settings Dropdown */}
//                                  {renderDynamicDropdown(
//                                     'printingSettings',
//                                     'Printing Settings',
//                                     PRINTING_SETTING_TYPE,
//                                     {
//                                        value: row.printingSettings,
//                                        onChange: (value) => handleInputChange('printingSettings', value),
//                                        ref: printingSettingsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              sendWhatsAppRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select Printing Settings',
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'sendWhatsApp',
//                                     'Send WhatsApp',
//                                     {
//                                        isChecked: row.sendWhatsApp,
//                                        onChange: handleSwitchChange('sendWhatsApp'),
//                                        ref: sendWhatsAppRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              wpSettingsRef.current?.focus();
//                                           }
//                                        },
//                                     },

//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {/* Printing Settings Dropdown */}
//                                  {renderDynamicDropdown(
//                                     'wpSettings',
//                                     'WhatsApp Settings',
//                                     PRINTING_SETTING_TYPE,
//                                     {
//                                        value: row.wpSettings,
//                                        onChange: (value) => handleInputChange('wpSettings', value),
//                                        ref: wpSettingsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              termsNConditionsRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     'Select WhatsApp Settings',
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderTextareaControl(
//                                     'termsNConditions',
//                                     'Terms and Conditions',
//                                     {
//                                        value: row.termsNConditions,
//                                        onChange: (e) => handleInputChange('termsNConditions', e.target.value),
//                                        ref: termsNConditionsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              savefinish.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                  )}
//                               </GridItem>
//                            </>
//                         )}

//                         {activeStep === 3 && (
//                            <>
//                               {['Bank'].includes(row.typeName) && (
//                                  <GridItem className="seperator-width">
//                                     {DynamicInput(
//                                        'accountNo',
//                                        'Account No.',
//                                        {
//                                           value: row.accountNo,
//                                           onChange: (e) => handleInputChange('accountNo', e.target.value),
//                                           ref: accountNoRef,
//                                           onKeyDown: (e) => {
//                                              if (e.key === 'Enter' || e.key === 'Tab') {
//                                                 e.preventDefault();
//                                                 shortNameRef.current?.focus();
//                                              }
//                                           },
//                                        },
//                                        errors,
//                                        textColor,
//                                        'text',
//                                        false,
//                                     )}
//                                  </GridItem>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'shortName',
//                                     'Short Name',
//                                     {
//                                        value: row.shortName,
//                                        onChange: (e) => handleInputChange('shortName', e.target.value),
//                                        ref: shortNameRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              printNameRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'printName',
//                                     'Print Name',
//                                     {
//                                        value: row.printName,
//                                        onChange: (e) => handleInputChange('printName', e.target.value),
//                                        ref: printNameRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              legalNameRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'legalName',
//                                     'Legal Name',
//                                     {
//                                        value: row.legalName,
//                                        onChange: (e) => handleInputChange('legalName', e.target.value),
//                                        ref: legalNameRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              notesRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'notes',
//                                     'Notes',
//                                     {
//                                        value: row.notes,
//                                        onChange: (e) => handleInputChange('notes', e.target.value),
//                                        ref: notesRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              remarksRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {DynamicInput(
//                                     'remarks',
//                                     'Remarks',
//                                     {
//                                        value: row.remarks,
//                                        onChange: (e) => handleInputChange('remarks', e.target.value),
//                                        ref: remarksRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              updateRateInItemRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     'text',
//                                     false,
//                                  )}
//                               </GridItem>

//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'updateRateInItem',
//                                     'Update Rate In Item',
//                                     {
//                                        isChecked: row.updateRateInItem,
//                                        onChange: handleSwitchChange('updateRateInItem'),
//                                        ref: updateRateInItemRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              itemWiseLastRateRef.current?.focus();
//                                           }
//                                        },
//                                     },

//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>

//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'itemWiseLastRate',
//                                     'Item Wise Last Rate',
//                                     {
//                                        isChecked: row.itemWiseLastRate,
//                                        onChange: handleSwitchChange('itemWiseLastRate'),
//                                        ref: itemWiseLastRateRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              partyItemWiseLastRateRef.current?.focus();
//                                           }
//                                        },
//                                     },

//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>

//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'partyItemWiseLastRate',
//                                     'Party Item Wise Last Rate',
//                                     {
//                                        isChecked: row.partyItemWiseLastRate,

//                                        onChange: handleSwitchChange('partyItemWiseLastRate'),
//                                        ref: partyItemWiseLastRateRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              reverseCalcOnItemQtyRef.current?.focus();
//                                           }
//                                        },
//                                     },

//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>

//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'reverseCalcOnItemQty',
//                                     'Reverse Calc On Item Qty',
//                                     {
//                                        isChecked: row.reverseCalcOnItemQty,

//                                        onChange: handleSwitchChange('reverseCalcOnItemQty'),
//                                        ref: reverseCalcOnItemQtyRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              TDSApplyOnRef.current?.focus();
//                                           }
//                                        },
//                                     },

//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>

//                               {/* <GridItem>
//                       {DynamicInput(
//                         'accountGroups',
//                         'Account Groups',
//                         {
//                           value: row.accountGroups,

//                           onChange: (e) =>
//                             handleInputChange('accountGroups', e.target.value),
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         false,
//                       )}
//                     </GridItem> */}

//                               <GridItem className="seperator-width">
//                                  {renderDynamicDropdown(
//                                     'TDSApplyOn',
//                                     'TDS Apply On',
//                                     TDS_APPLY_ON,
//                                     {
//                                        value: row.TDSApplyOn,

//                                        onChange: (value) => handleInputChange('TDSApplyOn', value),
//                                        ref: TDSApplyOnRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              askToGenerateInvoiceRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                  )}
//                               </GridItem>

//                               {/* <GridItem>
//                                  {renderDynamicDropdown2(
//                                     'askToGenerateInvoice',
//                                     'Ask To Generate Invoice',
//                                     ASK_TO_GENERATE_INVOICE_option,
//                                     {
//                                        value: row.askToGenerateInvoice,
//                                        onChange: (e) => handleInputChange('askToGenerateInvoice', e),
//                                        ref: askToGenerateInvoiceRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              askOnlinePaymentDetailsRef.current?.focus();
//                                           }
//                                        },
//                                     },

//                                     errors,
//                                     textColor,
//                                     true,
//                                     'Select Bank',
//                                     true, // isSearchable
//                                     undefined, // filteredOptions (optional, can be null or undefined)
//                                     true,
//                                  )} */}
//                               {/* <FormControl width="95%" display="flex" alignItems="center">
//                                     <FormLabel margin={0} width="60%">
//                                        Ask To Generate Invoice
//                                     </FormLabel>
//                                     <Select
//                                        placeholder="Select Ask To Generate Invoice"
//                                        name="askToGenerateInvoice"
//                                        options={ASK_TO_GENERATE_INVOICE?.map((item) => ({
//                                           label: item.name,
//                                           value: item.id,
//                                        }))}
//                                        value={row.askToGenerateInvoice}
//                                        onChange={(e) => handleSelectChange('askToGenerateInvoice', e)}
//                                        isMulti
//                                     />
//                                  </FormControl> */}
//                               {/* </GridItem> */}

//                               {/* <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'sendWhatsApp',
//                                     'Send WhatsApp',
//                                     {
//                                        isChecked: row.sendWhatsApp,
//                                        onChange: handleSwitchChange('sendWhatsApp'),
//                                     },

//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem> */}

//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'askOnlinePaymentDetails',
//                                     'Ask Online Payment Details',
//                                     {
//                                        isChecked: row.askOnlinePaymentDetails,
//                                        onChange: handleSwitchChange('askOnlinePaymentDetails'),
//                                        ref: askOnlinePaymentDetailsRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              isOldRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'isOld',
//                                     'Is Old',
//                                     {
//                                        isChecked: row.isOld,
//                                        onChange: handleSwitchChange('isOld'),
//                                        ref: isOldRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              purcherDaybookRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               {(row.type === 5 || row.type === 19) && (
//                                  <GridItem className="seperator-width">
//                                     {renderDynamicDropdown(
//                                        'purchaseDaybookId',
//                                        'Purchase Daybook',
//                                        daybookData,
//                                        {
//                                           value: row.purchaseDaybookId,
//                                           onChange: (value) => handleInputChange('purchaseDaybookId', value),
//                                           ref: purcherDaybookRef,
//                                           onKeyDown: (e) => {
//                                              if (e.key === 'Enter' || e.key === 'Tab') {
//                                                 e.preventDefault();
//                                                 savefinish.current?.focus();
//                                              }
//                                           },
//                                        },
//                                        errors,
//                                        textColor,
//                                        false,
//                                     )}
//                                  </GridItem>
//                               )}
//                               {row.type === 11 && (
//                                  <>
//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'isGrayPurchase',
//                                           'Is Gray Purchase',
//                                           {
//                                              isChecked: row.isGrayPurchase,
//                                              onChange: handleSwitchChange('isGrayPurchase'),
//                                              ref: isGrayPurchaseRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    purcherDaybookRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {renderSwitchControl(
//                                           'isMillReceive',
//                                           'Is Mill Receive',
//                                           {
//                                              isChecked: row.isMillReceive,
//                                              onChange: handleSwitchChange('isMillReceive'),
//                                              ref: isMillReceiveRef,
//                                              onKeyDown: (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    purcherDaybookRef.current?.focus();
//                                                 }
//                                              },
//                                           },
//                                           errors,
//                                           textColor,
//                                           false,
//                                           false,
//                                        )}
//                                     </GridItem>
//                                  </>
//                               )}
//                               {row.type === 19 && (
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'isMillIssue',
//                                        'Is Mill Issue',
//                                        {
//                                           isChecked: row.isMillIssue,
//                                           onChange: handleSwitchChange('isMillIssue'),
//                                           ref: isMillIssueRef,
//                                           onKeyDown: (e) => {
//                                              if (e.key === 'Enter' || e.key === 'Tab') {
//                                                 e.preventDefault();
//                                                 purcherDaybookRef.current?.focus();
//                                              }
//                                           },
//                                        },
//                                        errors,
//                                        textColor,
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>
//                               )}
//                               {Textile && (
//                                  <GridItem className="seperator-width">
//                                     {renderSwitchControl(
//                                        'isOtherJobWork',
//                                        'Is Other JobWork',
//                                        {
//                                           isChecked: row.isOtherJobWork,
//                                           onChange: handleSwitchChange('isOtherJobWork'),
//                                           ref: isOtherJobWorkRef,
//                                           onKeyDown: (e) => {
//                                              if (e.key === 'Enter' || e.key === 'Tab') {
//                                                 e.preventDefault();
//                                                 purcherDaybookRef.current?.focus();
//                                              }
//                                           },
//                                        },
//                                        errors,
//                                        textColor,
//                                        false,
//                                        false,
//                                     )}
//                                  </GridItem>
//                               )}
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'isAllowNotes',
//                                     'Is Allow Notes',
//                                     {
//                                        isChecked: row.isAllowNotes,
//                                        onChange: handleSwitchChange('isAllowNotes'),
//                                        ref: isAllowNotesRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              purcherDaybookRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                               <GridItem className="seperator-width">
//                                  {renderSwitchControl(
//                                     'isAllowRemark',
//                                     'Is Allow Remark',
//                                     {
//                                        isChecked: row.isAllowRemark,
//                                        onChange: handleSwitchChange('isAllowRemark'),
//                                        ref: isAllowRemarkRef,
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' || e.key === 'Tab') {
//                                              e.preventDefault();
//                                              purcherDaybookRef.current?.focus();
//                                           }
//                                        },
//                                     },
//                                     errors,
//                                     textColor,
//                                     false,
//                                     false,
//                                  )}
//                               </GridItem>
//                            </>
//                         )}
//                      </Grid>
//                   </GridItem>
//                </Grid>
//             </ModalBody>
//             <ModalFooter>
//                {activeStep > 0 && (
//                   <Button
//                      onClick={handlePrevious}
//                      variant="ghost"
//                      colorScheme="green"
//                      mr={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      Previous
//                   </Button>
//                )}
//                <Button
//                   onClick={handleNext}
//                   colorScheme="green"
//                   variant="ghost"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}>
//                   Next
//                </Button>

//                {!isEditMode && saveandcontinue === true && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      ml={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      save & continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSave}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   ref={savefinish}
//                   colorScheme="green"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}>
//                   Save & Finish
//                </Button>

//                {/* <Button onClick={handleNext} colorScheme="green" ml={3}>
//             {activeStep === steps.length - 1 ? 'Save' : 'Next'}
//           </Button> */}
//                <Button variant="ghost" onClick={handleCansel} ml={3} _focus={{ outlineColor: 'blue.500 ' }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default DaybookForm;

import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
   Box,
   useColorMode,
} from '@chakra-ui/react';
import { getAccount } from '../../../../../redux/actions/account';
import { useDispatch, useSelector } from 'react-redux';
import {
   addDaybook,
   updateDaybook,
   getDaybook,
   getDaybookForMaster,
   getIssueDaybook,
   getAllDaybooks,
} from '../../../../../redux/actions/daybook';
import {
   EntryFromType,
   LINE_ITEM_REACHED,
   OrderFieldRegion,
   SupplyTypes,
   TDS_APPLY_ON,
   ASK_TO_GENERATE_INVOICE,
} from '../../../../../utils/dropdownEnum';
import { TYPE, SUB_TYPE, METHOD_OF_ROUND_LI_TYPE, AUTO_ROUND_OFF_AT_TYPE, PRINTING_SETTING_TYPE } from './DaybookTypes';
import { WAREHOUSE_TYPE } from '../../../../../../src/variables/company';
import { renderSwitchControl } from 'utils/DynamicFormData';
import { renderTextareaControl } from 'utils/DynamicFormData';
import { getWarehouse } from '../../../../../redux/actions/warehouse';
import { getGLGroups } from '../../../../../redux/actions/glGroup';
import { getItemGroup } from '../../../../../redux/actions/itemGroup';
import '../../../companyProfile/css.css';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useGlobal, useUser } from '../../../../../contexts';

// Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
   type: Yup.string().required('Type is required'),
});

const steps = [
   { title: 'Basic', description: 'Set up basic information' },
   { title: 'Settings', description: 'Configure settings' },
   { title: 'Printing', description: 'Choose printing options' },
   { title: 'Others', description: 'Add other details' },
];

const DaybookForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   demoname,
   currentRow = null,
   saveandcontinue = true,
   type,
   search,
   apitype,
   isAbs = false,
}) => {
   const { companyList, userGlobalSettingsData } = useGlobal();
   const { user } = useUser();
   const dbName = localStorage.getItem('dbName');
   const [messageFormat, setMessageFormat] = useState('');
   const [error, setError] = useState('');
   const textareaRef = useRef(null);
   const highlightRef = useRef(null);
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );
   const [row, setRow] = useState({
      compIds: [],
      //1 Basic
      name: '',
      dueDays: '',
      type: type ? type : TYPE[1].id, //drop
      subType: SUB_TYPE[0].id, //drop
      entryFormType: 1, //drop - ENUM
      applyGst: false, // Check
      typeOfSupply: SupplyTypes[1].id, //Drop Enum
      isAskTypeOfSupply: false,
      isAllowExchange: false,
      isAllowGstRate: false,
      isOld: false,
      isAllowNotes: false,
      isAllowRemark: false,
      //1 Basic
      // 2 Settings
      accountId: null, //DROP
      itemgroups: [], //Textbox
      // accountGroup: '', //Textbox
      wareHouseId: null, //Drop
      warehouseInId: null, //Drop
      getTransportDetails: false, // Checkbox
      getPaymentDet: false, // Check
      getWorkDetails: false, // Check
      getOnlinePaymentDetails: false, // Check
      numOfLineItems: 0, // Textbox num
      actionIfLIReached: LINE_ITEM_REACHED[1].id, // Drop - enum
      defaultDate: null, //Text date
      forceOrderedDate: null, //TExt Date
      allowZeroAmounts: false, // Check
      allowEditLIAmount: false, // Check
      allowZeroQuantities: false, // Check
      allowIncreaseQty: false, // Check
      allowChangePrice: false, // Check
      autoCallOutAdj: false, // Check
      promptBeforeCallOsa: false, // Check
      orderFieldRegion: OrderFieldRegion[0].id, //Drop - Enum (header , Line Item)
      orderdaybookid: null, //Drop - daybook list
      issueFieldRegion: null, // Drop - Enum (header , Line Item)
      issuedaybookid: null, //Drop - daybook list
      challanFieldRegion: OrderFieldRegion[0].id, // Drop - Enum (header , Line Item)
      challandaybookid: null, //Drop - daybook list
      getLineDetail: false, // Check
      allowAutoIssue: false, // Check
      shouldAskSendSMS: false, // Check
      methodOfRoundT: METHOD_OF_ROUND_LI_TYPE[2].id, // Dropdown - Enum
      autoRoundOffAt: AUTO_ROUND_OFF_AT_TYPE[2].id, // Dropdown - Enum
      methodOfRoundLI: METHOD_OF_ROUND_LI_TYPE[1].id, // Dropdown - Enum
      issueDaybookId: null, //Drop - daybook list
      defaultaccountid: null, //Drop - account list
      // 2 Settings
      // 3 Printing
      titleMessage1: '', //Text
      titleMessage2: '', //Text
      headerMessage1: '', //Text
      headerMessage2: '', //Text
      footerMessage1: '', //Text
      footerMessage2: '', //Text
      accDocImgTerms: '', //Text
      accImgTerms: '', //Text
      onlinePrinting: true, //CHeck
      numOfCopies: 1, //Text num
      askBeforePrint: false, //check
      termsNConditions: '', // Textbox multiline 4
      // 3 Printing
      //4 others
      accountNo: '', //Text
      shortName: '', //Text
      printName: '', //Text
      legalName: '', //Text
      notes: '', //Text
      remarks: '', //Text
      customTemp: '', // Textbox multiline 1

      updateRateInItem: false, // Check
      itemWiseLastRate: false, // Check
      partyItemWiseLastRate: false, // Check
      reverseCalcOnItemQty: false, // Check
      accountgroups: [], // Textbox
      TDSApplyOn: 0, // Drop
      purchaseDaybookId: null,
      isGrayPurchase: false,
      isOtherJobWork: false,
      isMillIssue: false,
      isMillReceive: false,
      sendWhatsApp: false, // Check
      askToGenerateInvoice: [],
      askOnlinePaymentDetails: false, // Check
      requireDiscountLineItem: 1, // Text
      isAskToAllow: false,
      askPasswordOnDelete: false,
      isAskIncomeExpenses: false,
      isNotConsiderInStock: false, // Check

      //4 others
   });
   const [errors, setErrors] = useState({});
   const [activeStep, setActiveStep] = useState(0);
   const [isLoading, setIsLoading] = useState(false);
   const [company, setCompany] = useState(null);
   const applyGST = company?.setting?.applyGST;
   const enablePurchaseOrder = company?.setting?.enablePurchaseOrder;
   const enableSaleOrder = company?.setting?.enableSaleOrder;
   const enableSaleChallan = company?.setting?.enableSaleChallan;
   const enablePurchaseChallan = company?.setting?.enablePurchaseChallan;
   const warehouseWishStock = company?.setting?.warehouseWishStock;
   const toast = useToast();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const dispatch = useDispatch();
   const accountList = useSelector((state) => state.account.list);
   const daybookList = useSelector((state) => state.daybook.issueDaybook);
   const warehouseList = useSelector((state) => state.warehouse.list);
   const daybookData = useSelector((state) => state.daybook?.allDaybooks || []);
   // const companyList = useSelector((state) => state.company.list);
   const glGroupList = useSelector((state) => state.glGroup.list);
   const itemGroupList = useSelector((state) => state.itemGroup.list);

   const shouldSendCompanyidAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyidItemGroup = userGlobalSettingsData?.[0]?.askCompany?.itemGroup || false;
   const shouldSendCompanyidWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;

   const companyId = localStorage.getItem('companyId');

   const businessType = localStorage.getItem('businessTypes');
   const mobile = businessType === 'MOBILE';
   const Textile = businessType === 'TEXTILE';

   const clearFormData = () => {
      setRow({
         //1 Basic
         name: '',
         dueDays: '',
         type: '',
         subType: 0,
         entryFormType: 1,
         applyGst: false,
         typeOfSupply: null,
         isAskTypeOfSupply: false,
         isAllowExchange: false,
         isAllowGstRate: false,
         isOld: false,
         isAllowNotes: false,
         isAllowRemark: false,
         //1 Basic
         // 2 Settings
         accountId: null,
         itemgroups: [],
         wareHouseId: null,
         warehouseInId: null,
         getTransportDetails: false,
         getPaymentDet: false,
         getWorkDetails: false,
         getOnlinePaymentDetails: false,
         numOfLineItems: 0,
         actionIfLIReached: 1,
         defaultDate: null,
         forceOrderedDate: null,
         allowZeroAmounts: false,
         allowEditLIAmount: false,
         allowZeroQuantities: false,
         allowIncreaseQty: false,
         allowChangePrice: false,
         autoCallOutAdj: false,
         promptBeforeCallOsa: false,
         orderFieldRegion: 0,
         orderdaybookid: null,
         issueFieldRegion: null,
         issuedaybookid: null,
         challanFieldRegion: 0,
         challandaybookid: null,
         getLineDetail: false,
         allowAutoIssue: false,
         shouldAskSendSMS: false,
         methodOfRoundT: null,
         autoRoundOffAt: null,
         methodOfRoundLI: null,
         issueDaybookId: '',
         defaultaccountid: null,
         // 2 Settings
         // 3 Printing
         titleMessage1: '',
         titleMessage2: '',
         headerMessage1: '',
         headerMessage2: '',
         footerMessage1: '',
         footerMessage2: '',
         accDocImgTerms: '',
         accImgTerms: '',
         onlinePrinting: true,
         numOfCopies: 1,
         printingSettings: 0,
         wpSettings: 0,
         ewayBill: false,
         ewayInvoice: false,
         askBeforePrint: false,
         termsNConditions: '',
         // 3 Printing
         //4 others
         accountNo: '',
         shortName: '',
         printName: '',
         legalName: '',
         notes: '',
         remarks: '',
         customTemp: '',
         gstUniqueID: null,
         //4 others
         updateRateInItem: false, // Check
         itemWiseLastRate: false, // Check
         partyItemWiseLastRate: false, // Check
         reverseCalcOnItemQty: false, // Check
         accountgroups: [], // Textbox
         TDSApplyOn: 2, // Drop
         purchaseDaybookId: null,
         isGrayPurchase: false,
         isOtherJobWork: false,
         isMillIssue: false,
         isMillReceive: false,
         sendWhatsApp: false, // Check
         askToGenerateInvoice: [],
         askOnlinePaymentDetails: false, // Check
         requireDiscountLineItem: 1, // Text
         isAskToAllow: false,
         askPasswordOnDelete: false,
         isAskIncomeExpenses: false,
         isNotConsiderInStock: false, // Check
      });
      setErrors({});
   };

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         // Only set if not in edit mode and compIds is empty or doesn't include the user's company
         setRow((prev) => {
            if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  compIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
         setRow((prev) => ({
            ...prev,
            compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
         }));
      } else if (isEditMode && currentRow) {
         setRow({
            //1 Basic
            name: currentRow.name,
            dueDays: currentRow.dueDays,
            type: currentRow.type || type,
            subType: currentRow.subType,
            accountId: currentRow.accountId,
            entryFormType: currentRow.entryFormType,
            isAskTypeOfSupply: currentRow.isAskTypeOfSupply,
            isAllowExchange: currentRow.isAllowExchange,
            isAllowGstRate: currentRow.isAllowGstRate,
            isOld: currentRow.isOld,
            isAllowNotes: currentRow.isAllowNotes,
            isAllowRemark: currentRow.isAllowRemark,
            compIds: currentRow?.companyIds || [],
            //1 Basic
            // 2 Settings
            defaultaccountid: currentRow.defaultaccountid || null,
            // itemgroups: currentRow.itemgroups,

            itemgroups: (Array.isArray(itemGroupList) ? itemGroupList : [])
               .map((item) => ({
                  label: item.name,
                  value: item.id,
               }))
               .filter((item) => Array.isArray(currentRow?.itemgroups) && currentRow.itemgroups.includes(item.value)),

            accountgroups: glGroupList
               .map((item) => ({
                  label: item.name,
                  value: item.id,
               }))
               .filter((item) => currentRow.accountgroups?.includes(item.value)),

            wareHouseId: currentRow.wareHouseId,
            warehouseInId: currentRow.warehouseInId,
            getTransportDetails: currentRow.getTransportDetails,
            getPaymentDet: currentRow.getPaymentDet,
            getWorkDetails: currentRow.getWorkDetails,
            getOnlinePaymentDetails: currentRow.getOnlinePaymentDetails,
            numOfLineItems: currentRow.numOfLineItems || 0,
            actionIfLIReached: currentRow.actionIfLIReached,
            defaultDate: currentRow.defaultDate,
            // defaultDate: new Date(currentRow.defaultDate)
            //   .toISOString()
            //   .split('T')[0],
            forceOrderedDate: currentRow.forceOrderedDate,
            // forceOrderedDate: new Date(currentRow.forceOrderedDate)
            //   .toISOString()
            //   .split('T')[0],
            allowZeroAmounts: currentRow.allowZeroAmounts,
            allowEditLIAmount: currentRow.allowEditLIAmount,
            allowZeroQuantities: currentRow.allowZeroQuantities,
            allowIncreaseQty: currentRow.allowIncreaseQty,
            allowChangePrice: currentRow.allowChangePrice,
            autoCallOutAdj: currentRow.autoCallOutAdj,
            promptBeforeCallOsa: currentRow.promptBeforeCallOsa,
            orderFieldRegion: currentRow.orderFieldRegion,
            orderdaybookid: currentRow.orderdaybookid,
            issueFieldRegion: currentRow.issueFieldRegion,
            issuedaybookid: currentRow.issuedaybookid,
            challanFieldRegion: currentRow.challanFieldRegion,
            challandaybookid: Number(currentRow.challandaybookid),
            getLineDetail: currentRow.getLineDetail,
            allowAutoIssue: currentRow.allowAutoIssue,
            shouldAskSendSMS: currentRow.shouldAskSendSMS,
            methodOfRoundT: currentRow.methodOfRoundT,
            autoRoundOffAt: currentRow.autoRoundOffAt,
            methodOfRoundLI: currentRow.methodOfRoundLI,
            issueDaybookId: currentRow.issueDaybookId,
            // 2 Settings
            // 3 Printing
            titleMessage1: currentRow.titleMessage1,
            titleMessage2: currentRow.titleMessage2,
            headerMessage1: currentRow.headerMessage1,
            headerMessage2: currentRow.headerMessage2,
            footerMessage1: currentRow.footerMessage1,
            footerMessage2: currentRow.footerMessage2,
            accDocImgTerms: currentRow.accDocImgTerms,
            accImgTerms: currentRow.accImgTerms,
            onlinePrinting: currentRow.onlinePrinting,
            numOfCopies: currentRow.numOfCopies,
            printingSettings: currentRow.printingSettings,
            wpSettings: currentRow.wpSettings,
            ewayBill: currentRow.ewayBill,
            ewayInvoice: currentRow.ewayInvoice,
            askBeforePrint: currentRow.askBeforePrint,
            termsNConditions: currentRow.termsNConditions,
            // 3 Printing
            // 4 GST Details
            applyGst: currentRow.applyGst,
            gstType: currentRow.gstType,
            gstSubType: currentRow.gstSubType,
            typeOfSupply: currentRow.typeOfSupply,
            customTemp: currentRow.customTemp,
            // 4 GST Details
            //5 others
            accountNo: currentRow.accountNo,
            shortName: currentRow.shortName,
            printName: currentRow.printName,
            legalName: currentRow.legalName,
            notes: currentRow.notes,
            remarks: currentRow.remarks,
            gstUniqueID: currentRow.gstUniqueID,
            updateRateInItem: currentRow.updateRateInItem,
            itemWiseLastRate: currentRow.itemWiseLastRate,
            partyItemWiseLastRate: currentRow.partyItemWiseLastRate,
            reverseCalcOnItemQty: currentRow.reverseCalcOnItemQty,
            sendWhatsApp: currentRow.sendWhatsApp,
            TDSApplyOn: currentRow.TDSApplyOn,
            purchaseDaybookId: currentRow.purchaseDaybookId,
            isGrayPurchase: currentRow.isGrayPurchase,
            isOtherJobWork: currentRow.isOtherJobWork,
            isMillIssue: currentRow.isMillIssue,
            isMillReceive: currentRow.isMillReceive,
            askOnlinePaymentDetails: currentRow.askOnlinePaymentDetails,
            requireDiscountLineItem: currentRow.requireDiscountLineItem,
            //5 others

            isAskToAllow: currentRow.isAskToAllow,
            askPasswordOnDelete: currentRow.askPasswordOnDelete,
            isAskIncomeExpenses: currentRow.isAskIncomeExpenses,
            isNotConsiderInStock: currentRow.isNotConsiderInStock,

            askToGenerateInvoice: ASK_TO_GENERATE_INVOICE?.map((item) => ({
               label: item.name,
               value: item.value,
            })).filter((item) => currentRow.askToGenerateInvoice?.includes(item.value)),
         });
      }
   }, [isEditMode, currentRow, itemGroupList, glGroupList]);

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      if (field === 'wareHouseId') {
         setRow((prev) => ({ ...prev, [field]: value === '' ? null : value }));
         setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (newErrors[field]) {
               delete newErrors[field];
            }
            return newErrors;
         });
      } else {
         setRow((prev) => ({ ...prev, [field]: value }));
         setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (newErrors[field]) {
               delete newErrors[field];
            }
            return newErrors;
         });
      }
   };

   const handleSwitchChange = (field) => (event) => {
      setRow((prev) => ({
         ...prev,
         [field]: event.target.checked, // Updates boolean value (true/false)
      }));
   };

   const handleSelectChange = (field, value) => {
      if (field === 'askToGenerateInvoice') {
         if (value?.map((item) => item.value)?.includes(2)) {
            setRow((prev) => ({
               ...prev,
               [field]: value
                  ?.map((item) => {
                     if (item.value === 2) return item;
                     return null;
                  })
                  ?.filter((x) => x !== null),
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               [field]: value
                  ?.map((item) => {
                     if ([0, 1]?.includes(item.value)) return item;
                     return null;
                  })
                  ?.filter((x) => x !== null),
            }));
         }
      }
      if (['itemgroups', 'accountgroups']?.includes(field)) {
         setRow((prev) => ({
            ...prev,
            [field]: [value],
         }));
      }
   };

   const onFormSubmit = async () => {
      try {
         setIsLoading(true);
         const processedData = {
            ...row,
            type: Number(row.type),
            compIds: row.compIds,
            subType: Number(row.subType),
            challandaybookid: row.challandaybookid ? row.challandaybookid.toString() : null,
            // askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item.value) ?? []),
            askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item) ?? []),
            // itemgroups: row.itemgroups?.map((item) => Number(item.value) ?? []),
            itemgroups: row.itemgroups?.map((item) => Number(item) ?? []),
            // accountgroups: row.accountgroups?.map((item) => Number(item.value) ?? []),
            accountgroups: row.accountgroups?.map((item) => Number(item) ?? []),
            customTemp: row.customTemp || '',
            isAskTypeOfSupply: row.isAskTypeOfSupply,
            isAllowExchange: row.isAllowExchange,
            isAllowGstRate: row.isAllowGstRate,
            isOld: row.isOld,
            isAllowNotes: row.isAllowNotes,
            isAllowRemark: row.isAllowRemark,
            isGrayPurchase: row.isGrayPurchase,
            isOtherJobWork: row.isOtherJobWork,
            isMillIssue: row.isMillIssue,
            isMillReceive: row.isMillReceive,
            issuedaybookid: row.issuedaybookid || null,
            isAskToAllow: row.isAskToAllow,
            askPasswordOnDelete: row.askPasswordOnDelete,
            isAskIncomeExpenses: row.isAskIncomeExpenses,
            isNotConsiderInStock: row.isNotConsiderInStock,
            requireDiscountLineItem: Number(row.requireDiscountLineItem),
            purchaseDaybookId: row.type === 5 ? row.purchaseDaybookId : null,
         };

         if (isEditMode && currentRow?.id) {
            processedData.id = currentRow.id;
            dispatch(updateDaybook(processedData));
         } else {
            dispatch(addDaybook(processedData));
         }
         // await dispatch(
         //    getDaybook({
         //       companyId: Number(user?.loginhistory?.companyId),
         //       page: 1,
         //       limit: 10,
         //       sortBy: 'id',
         //       sortOrder: 'desc',
         //    }),
         // );
         await dispatch(getDaybookForMaster({ companyId: Number(user?.loginhistory?.companyId) }));
         await dispatch(getDaybook({ companyId: Number(user?.loginhistory?.companyId) }));
         clearFormData();
         setActiveStep(0);
         onClose();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Daybook.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      try {
         setIsLoading(true);
         const processedData = {
            ...row,
            type: Number(row.type),
            subType: Number(row.subType),
            challandaybookid: row.challandaybookid ? row.challandaybookid.toString() : null,
            // askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item.value) ?? []),
            askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item) ?? []),
            // itemgroups: row.itemgroups?.map((item) => Number(item.value) ?? []),
            itemgroups: row.itemgroups?.map((item) => Number(item) ?? []),
            // accountgroups: row.accountgroups?.map((item) => Number(item.value) ?? []),
            accountgroups: row.accountgroups?.map((item) => Number(item) ?? []),
            isAskTypeOfSupply: row.isAskTypeOfSupply,
            isAllowExchange: row.isAllowExchange,
            isAllowGstRate: row.isAllowGstRate,
            isOld: row.isOld,
            isAllowNotes: row.isAllowNotes,
            isAllowRemark: row.isAllowRemark,
            isAskToAllow: row.isAskToAllow,
            askPasswordOnDelete: row.askPasswordOnDelete,
            isAskIncomeExpenses: row.isAskIncomeExpenses,
            isNotConsiderInStock: row.isNotConsiderInStock,
            requireDiscountLineItem: Number(row.requireDiscountLineItem),
         };

         if (isEditMode && currentRow?.id) {
            processedData.id = currentRow.id;
            dispatch(updateDaybook(processedData));
         } else {
            dispatch(addDaybook(processedData));
         }
         // dispatch(
         //    getDaybook({
         //       companyId: user?.loginhistory?.companyId,
         //       page: 1,
         //       limit: 10,
         //       sortBy: 'id',
         //       sortOrder: 'desc',
         //    }),
         // );
         clearFormData();
         setActiveStep(0);
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Daybook.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const handleNext = async () => {
      const isValid = await validateStep();
      if (isValid) {
         if (activeStep < steps.length - 1) {
            setActiveStep(activeStep + 1);
         } else {
            onFormSubmit();
         }
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' || // for react-select input
            activeElement?.isContentEditable;

         if (isTyping) return; // Don't trigger shortcuts while typing

         if (isOpen && e.key.toLowerCase() === 's') {
            // e.preventDefault(); // prevent browser default (e.g. save page)

            if (e.shiftKey) {
               handlesavecontinue(); // SHIFT + S
            } else {
               handleSave(); // S only
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            handleCansel();
         }
         if (isOpen && e.key.toLowerCase() === 'n') {
            handleNext();
         }
         if (isOpen && e.key === 'Escape') {
            e.stopPropagation(); // Prevent event from bubbling to parent
            onClose();
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   const handleSave = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit();
      } else {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               typeRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               subtypeRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue();
      } else {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               typeRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               subtypeRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlePrevious = () => {
      if (activeStep > 0) {
         setActiveStep(activeStep - 1);
      }
   };

   useEffect(() => {
      if (isOpen) {
         dispatch(
            getAccount({
               compId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(getWarehouse({ ...(shouldSendCompanyidWarehouse && { companyIds: user?.loginhistory?.companyId }) }));
         dispatch(
            getIssueDaybook({
               type: 19,
               ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
               companyId: user?.loginhistory?.companyId,
            }),
         );
         dispatch(
            getAllDaybooks({
               companyId: user?.loginhistory?.companyId,
               type: 11,
               ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(getItemGroup({ ...(shouldSendCompanyidItemGroup && { companyIds: user?.loginhistory?.companyId }) }));
         dispatch(getGLGroups());
         // dispatch(getCompanies());
      }
   }, [dispatch, isOpen]);

   useEffect(() => {
      if (companyList.length > 0 && companyId) {
         const company = companyList.find((company) => company.id.toString() === companyId.toString());
         setCompany(company);
      }
   }, [companyList, companyId]);

   const itemgroupsoptions = (Array.isArray(itemGroupList) ? itemGroupList : []).map((item) => ({
      label: item.name,
      value: item.id,
      name: item.name,
      id: item.id,
   }));

   const accountgroupsoptions = (Array.isArray(glGroupList) ? glGroupList : []).map((item) => ({
      label: item.name,
      value: item.id,
      name: item.name,
      id: item.id,
   }));
   const ASK_TO_GENERATE_INVOICE_option = ASK_TO_GENERATE_INVOICE?.map((item) => ({
      label: item.name,
      value: item.id,
      name: item.name,
      id: item.id,
   }));

   // options={glGroupList?.map((item) => ({
   //    label: item.name,
   //    value: item.id,
   // }))}

   const nameInputRef = useRef();
   const typeRef = useRef();
   const subtypeRef = useRef();
   const entryFormTypeRef = useRef();
   const typeOfSupplyRef = useRef();
   const applyGstRef = useRef();
   const accountRef = useRef();
   const isAskTypeOfSupplyRef = useRef();
   const companyRef = useRef();
   const isAllowExchangeRef = useRef();
   const isAllowGstRateRef = useRef();
   const savefinish = useRef();
   const accountgroupsRef = useRef();
   const defaultaccountRef = useRef();
   const itemgroupsRef = useRef();
   const defaultDateRef = useRef();
   const actionIfLIReachedRef = useRef();
   const getWorkDetailsRef = useRef();
   const getOnlinePaymentDetailsRef = useRef();
   const numOfLineItemsRef = useRef();
   const getPaymentDetRef = useRef();
   const getTransportDetailsRef = useRef();
   const wareHouseRef = useRef();
   const wareHouseInRef = useRef();
   const shouldAskSendSMSRef = useRef();
   const challandaybookRef = useRef();
   const getLineDetailRef = useRef();
   const allowAutoIssueRef = useRef();
   const challanFieldRegionRef = useRef();
   const issuedaybookRef = useRef();
   const issueFieldRegionRef = useRef();
   const promptBeforeCallOsaRef = useRef();
   const orderFieldRegionRef = useRef();
   const orderdaybookRef = useRef();
   const allowIncreaseQtyRef = useRef();
   const allowChangePriceRef = useRef();
   const autoCallOutAdjRef = useRef();
   const allowZeroAmountsRef = useRef();
   const allowEditLIAmountRef = useRef();
   const allowZeroQuantitiesRef = useRef();
   const forceOrderedDateRef = useRef();
   const isAskToAllowRef = useRef();
   const askPasswordOnDeleteRef = useRef();
   const isAskIncomeExpensesRef = useRef();
   const dueDaysInputRef = useRef();
   const isNotConsiderInStockRef = useRef();
   const methodOfRoundLIRef = useRef();
   const autoRoundOffAtRef = useRef();
   const requireDiscountLineItemRef = useRef();
   const methodOfRoundTRef = useRef();
   const titleMessage1Ref = useRef();
   const footerMessage1Ref = useRef();
   const headerMessage2Ref = useRef();
   const headerMessage1Ref = useRef();
   const titleMessage2Ref = useRef();
   const termsNConditionsRef = useRef();
   const wpSettingsRef = useRef();
   const sendWhatsAppRef = useRef();
   const ewayInvoiceRef = useRef();
   const printingSettingsRef = useRef();
   const accImgTermsRef = useRef();
   const accDocImgTermsRef = useRef();
   const ewayBillRef = useRef();
   const onlinePrintingRef = useRef();
   const numOfCopiesRef = useRef();
   const askBeforePrintRef = useRef();
   const footerMessage2Ref = useRef();
   const isOldRef = useRef();
   const isAllowNotesRef = useRef();
   const isAllowRemarkRef = useRef();
   const askOnlinePaymentDetailsRef = useRef();
   const reverseCalcOnItemQtyRef = useRef();
   const TDSApplyOnRef = useRef();
   const purcherDaybookRef = useRef();
   const isGrayPurchaseRef = useRef();
   const isMillIssueRef = useRef();
   const isMillReceiveRef = useRef();
   const isOtherJobWorkRef = useRef();
   const askToGenerateInvoiceRef = useRef();
   const updateRateInItemRef = useRef();
   const itemWiseLastRateRef = useRef();
   const partyItemWiseLastRateRef = useRef();
   const remarksRef = useRef();
   const legalNameRef = useRef();
   const notesRef = useRef();
   const accountNoRef = useRef();
   const shortNameRef = useRef();
   const printNameRef = useRef();
   // const notesRef = useRef();

   const handleCansel = useCallback(async () => {
      onClose();
      if (!isEditMode) {
         clearFormData();
      }
      await dispatch(getAllDaybooks({ companyId: Number(user?.loginhistory?.companyId) }));
   });

   useEffect(() => {
      if (demoname && row.name === '') {
         setRow((prev) => ({ ...prev, name: demoname }));
      }
      demoname = '';
   }, [demoname, row.name]);

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isOpen]);

   useEffect(() => {
      if (activeStep === 1) {
         setTimeout(() => {
            defaultaccountRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 2) {
         setTimeout(() => {
            titleMessage1Ref.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 3) {
         setTimeout(() => {
            accountNoRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            handleCansel();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleCansel]);

   const handleFocusMove = (e, nextRef, prevRef) => {
      if (e.key === 'Tab' || e.key === 'Enter') {
         e.preventDefault(); // Prevent default tab/enter behavior
         if (e.shiftKey) {
            // Move to previous input if Shift is pressed
            prevRef?.current?.focus();
         } else {
            // Move to next input
            nextRef?.current?.focus();
         }
      }
   };

   const insertKeyIntoMessage = (key) => {
      const textarea = textareaRef.current;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = row.customTemp || '';
      const before = text.substring(0, start);
      const after = text.substring(end);

      const newText = before + `{${key}}` + after;

      // Update both messageFormat state and row.customTemp
      setMessageFormat(newText);
      setRow((prev) => ({ ...prev, customTemp: newText }));

      // Set cursor position after inserted key
      setTimeout(() => {
         textarea.focus();
         textarea.setSelectionRange(start + key.length + 2, start + key.length + 2);
      }, 0);
   };
   const handleCustomTempChange = (e) => {
      const value = e.target.value;
      setMessageFormat(value);
      setRow((prev) => ({ ...prev, customTemp: value }));
   };

   const renderColoredText = (text) => {
      if (!text) return null;

      const parts = text.split(/(\{[^}]+\})/g);
      return parts.map((part, index) => {
         if (part.match(/\{[^}]+\}/)) {
            return (
               <span key={index} style={{ color: '#2563eb', fontWeight: '600' }}>
                  {part}
               </span>
            );
         }
         return <span key={index}>{part}</span>;
      });
   };

   const getHighlightedText = (text) => {
      if (!text) return '';
      // Replace variables with colored HTML
      return text.replace(
         /\{([^}]+)\}/g,
         '<span style="background-color: #dbeafe; color: #1e40af; font-weight: 600; padding: 0 4px; border-radius: 3px;">&#123;$1&#125;</span>',
      );
   };

   // Add scroll sync handler
   const handleTextareaScroll = () => {
      if (highlightRef.current && textareaRef.current) {
         highlightRef.current.scrollTop = textareaRef.current.scrollTop;
         highlightRef.current.scrollLeft = textareaRef.current.scrollLeft;
      }
   };

   const insertDemoFormat = (format) => {
      // Update the row.customTemp with new format
      handleCustomTempChange({ target: { value: format } });

      // Reset scroll position
      setTimeout(() => {
         if (textareaRef.current) {
            textareaRef.current.scrollTop = 0;
         }
         if (highlightRef.current) {
            highlightRef.current.scrollTop = 0;
         }
      }, 0);
   };

   return (
      <Modal isOpen={isOpen} onClose={handleCansel} size="6xl" scrollBehavior="inside">
         <ModalOverlay bg={isDark ? 'blackAlpha.700' : 'blackAlpha.500'} backdropFilter="blur(4px)" />
         <ModalContent
            bg={isDark ? 'gray.800' : 'white'}
            p={0}
            mx="15px"
            mt={{ base: '20px', md: '40px', xl: '60px' }}
            mb={{ base: '20px', md: '40px', xl: '60px' }}
            maxH="calc(100vh - 120px)"
            boxShadow={isDark ? '0 25px 50px -12px rgba(0, 0, 0, 0.5)' : '0 25px 50px -12px rgba(0, 0, 0, 0.25)'}
            border={isDark ? '1px solid' : 'none'}
            borderColor={isDark ? 'gray.700' : 'transparent'}
            display="flex"
            flexDirection="column">
            {/* Header with gradient - Fixed */}
            <ModalHeader
               className={`relative rounded-t-md overflow-hidden ${isDark
                     ? 'bg-gradient-to-r from-blue-900/80 via-purple-900/80 to-indigo-900/80 border-b border-blue-700/50'
                     : 'bg-gradient-to-r from-blue-50 via-purple-50 to-indigo-50 border-b border-blue-200'
                  }`}
               fontSize="22px"
               fontWeight="800"
               py={4}
               px={6}
               flexShrink={0}>
               <div className="flex items-center gap-3">
                  <div
                     className={`p-1 rounded-xl ${isDark ? 'bg-blue-600/20 border border-blue-500/30' : 'bg-blue-100 border border-blue-200'
                        }`}>
                     {isEditMode ? '✏️' : '✨'}
                  </div>
                  <span
                     className={`bg-gradient-to-r ${isDark ? 'from-blue-200 to-purple-200' : 'from-blue-600 to-purple-600'
                        } bg-clip-text text-transparent`}>
                     {isEditMode ? 'Edit Daybook' : 'Add New Daybook'}
                  </span>
               </div>
               <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-cyan-500"></div>
            </ModalHeader>

            <ModalCloseButton
               className={`absolute top-4 right-6 ${isDark
                     ? 'text-gray-300 hover:text-white hover:bg-red-600/20 border border-gray-600'
                     : 'text-gray-600 hover:text-gray-900 hover:bg-red-100 border border-gray-300'
                  } transition-all duration-200 rounded-xl w-8 h-8`}
               _focus={{ boxShadow: 'none' }}
            />

            {/* Scrollable Body */}
            <ModalBody p={3} overflow="auto" flex="1">
               <Grid h="auto" templateColumns="repeat(1, 1fr)" gap={4}>
                  {/* Stepper Section - Fixed at top of scroll area */}
                  <div
                     className={`
                  ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-gray-50 border-gray-300'} 
                  rounded-xl p-5 mb-6 shadow-sm border-2
               `}>
                     <div className="flex items-center justify-between">
                        {steps.map((step, index) => (
                           <div key={index} className="flex items-center flex-1">
                              <div className="flex flex-col items-center flex-1">
                                 <button
                                    onClick={() => setActiveStep(index)}
                                    className={`transition-all duration-300 hover:scale-105 ${activeStep === index ? 'transform scale-110' : ''
                                       }`}>
                                    <div
                                       className={`
                                    w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all duration-300
                                    ${activeStep === index
                                             ? isDark
                                                ? 'bg-purple-600 border-purple-500'
                                                : 'bg-blue-500 border-blue-400'
                                             : isDark
                                                ? 'border-gray-500'
                                                : 'border-gray-400'
                                          }
                                    ${activeStep > index
                                             ? isDark
                                                ? 'bg-green-600 border-green-500'
                                                : 'bg-green-500 border-green-400'
                                             : ''
                                          }
                                 `}>
                                       {activeStep > index ? (
                                          <span className="text-white">✓</span>
                                       ) : (
                                          <span
                                             className={`
                                          ${activeStep === index
                                                   ? 'text-white'
                                                   : isDark
                                                      ? 'text-gray-300'
                                                      : 'text-gray-600'
                                                }
                                       `}>
                                             {index + 1}
                                          </span>
                                       )}
                                    </div>
                                 </button>
                                 <span
                                    className={`
                                 text-xs font-semibold mt-2 text-center
                                 ${isDark ? 'text-gray-300' : 'text-gray-700'}
                              `}>
                                    {step.title}
                                 </span>
                              </div>
                              {index < steps.length - 1 && (
                                 <div
                                    className={`
                                 flex-1 h-0.5 mx-4
                                 ${isDark ? 'bg-gray-600' : 'bg-gray-300'}
                              `}
                                 />
                              )}
                           </div>
                        ))}
                     </div>
                  </div>

                  {/* Form Section */}
                  <GridItem>
                     <Box
                        bg={isDark ? 'gray.900' : 'white'}
                        border="1px solid"
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        borderRadius="16px"
                        p={6}
                        boxShadow={isDark ? '0 4px 6px -1px rgba(0, 0, 0, 0.3)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
                        <Grid
                           templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' }}
                           gap={5}>
                           {activeStep === 0 && (
                              <>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'name',
                                       'Name',
                                       {
                                          value: row.name,
                                          onChange: (e) => handleInputChange('name', e.target.value),
                                          disabled: isEditMode && isAbs,
                                          ref: nameInputRef,
                                          // onKeyDown: (e) => {
                                          //    if (e.key === 'Enter' || e.key === 'Tab') {
                                          //       e.preventDefault();
                                          //       typeRef.current?.focus();
                                          //    }
                                          // },
                                          onKeyDown: (e) => handleFocusMove(e, typeRef, null),
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       true,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'type',
                                       'Type',
                                       TYPE,
                                       {
                                          value: row.type || type,
                                          onChange: (value) => {
                                             const selectedOption = TYPE?.find(
                                                (item) => item.value === value || item.id === value,
                                             );
                                             handleInputChange('type', value);
                                             if (selectedOption) {
                                                handleInputChange(
                                                   'typeName',
                                                   selectedOption.name || selectedOption.label,
                                                );
                                             }
                                          },
                                          disabled: isEditMode && isAbs,
                                          ref: typeRef,
                                          nextRef: Textile
                                             ? subtypeRef
                                             : ![
                                                'Cash',
                                                'Bank',
                                                'Debit Note',
                                                'Credit Note',
                                                'Journal Voucher',
                                             ].includes(row.typeName)
                                                ? entryFormTypeRef
                                                : company && company?.gstRegNo
                                                   ? applyGstRef
                                                   : accountRef,
                                       },
                                       errors,
                                       textColor,
                                       true,
                                       'Select Type',
                                    )}
                                 </GridItem>
                                 {Textile && (
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'subType',
                                          'Sub Type',
                                          SUB_TYPE,
                                          {
                                             value: row.subType,
                                             onChange: (value) => {
                                                handleInputChange('subType', value);
                                             },
                                             ref: subtypeRef,
                                             nextRef: ![
                                                'Cash',
                                                'Bank',
                                                'Debit Note',
                                                'Credit Note',
                                                'Journal Voucher',
                                             ].includes(row.typeName)
                                                ? entryFormTypeRef
                                                : company && company?.gstRegNo
                                                   ? applyGstRef
                                                   : accountRef,
                                          },
                                          errors,
                                          textColor,
                                          true,
                                          'Select Sub type',
                                       )}
                                    </GridItem>
                                 )}
                                 {!['Cash', 'Bank', 'Debit Note', 'Credit Note', 'Journal Voucher'].includes(
                                    row.typeName,
                                 ) && (
                                       <>
                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'entryFormType',
                                                'Form Type',
                                                EntryFromType,
                                                {
                                                   value: row.entryFormType || EntryFromType[0].id,
                                                   onChange: (value) => handleInputChange('entryFormType', value),
                                                   ref: entryFormTypeRef,
                                                   nextRef: typeOfSupplyRef,
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Form Type',
                                             )}
                                          </GridItem>
                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'typeOfSupply',
                                                'Supply Type',
                                                SupplyTypes,
                                                {
                                                   value: row.typeOfSupply || SupplyTypes[1].id,
                                                   onChange: (value) => handleInputChange('typeOfSupply', value),
                                                   ref: typeOfSupplyRef,
                                                   nextRef: company && company?.gstRegNo ? applyGstRef : accountRef,
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Type of Supply',
                                             )}
                                          </GridItem>
                                       </>
                                    )}
                                 {company && company?.gstRegNo && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'applyGst',
                                          'Apply GST',
                                          {
                                             isChecked: row.applyGst,
                                             onChange: handleSwitchChange('applyGst'),
                                             ref: applyGstRef,
                                             // onKeyDown: (e) => {
                                             //    if (e.key === 'Enter' || e.key === 'Tab') {
                                             //       e.preventDefault();
                                             //       accountRef.current?.focus();
                                             //    }
                                             // },
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   accountRef,
                                                   ![
                                                      'Cash',
                                                      'Bank',
                                                      'Debit Note',
                                                      'Credit Note',
                                                      'Journal Voucher',
                                                   ].includes(row.typeName)
                                                      ? typeOfSupplyRef
                                                      : Textile
                                                         ? subtypeRef
                                                         : typeRef,
                                                ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'accountId',
                                       'Account',
                                       accountList,
                                       {
                                          value: row.accountId,
                                          onChange: (value) => handleInputChange('accountId', value),
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                          ref: accountRef,
                                          // onKeyDown: (e) => {
                                          //    if (e.key === 'Enter' || e.key === 'Tab') {
                                          //       e.preventDefault();
                                          //       isAskTypeOfSupplyRef.current?.focus();
                                          //    }
                                          // },
                                          onKeyDown: (e) =>
                                             handleFocusMove(
                                                e,
                                                isAskTypeOfSupplyRef,
                                                company && company?.gstRegNo
                                                   ? applyGstRef
                                                   : ![
                                                      'Cash',
                                                      'Bank',
                                                      'Debit Note',
                                                      'Credit Note',
                                                      'Journal Voucher',
                                                   ].includes(row.typeName)
                                                      ? entryFormTypeRef
                                                      : Textile
                                                         ? subtypeRef
                                                         : typeRef,
                                             ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Account',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isAskTypeOfSupply',
                                       'Ask Type Of Supply',
                                       {
                                          isChecked: row.isAskTypeOfSupply,
                                          onChange: handleSwitchChange('isAskTypeOfSupply'),
                                          ref: isAskTypeOfSupplyRef,
                                          // onKeyDown: (e) => {
                                          //    if (e.key === 'Enter' || e.key === 'Tab') {
                                          //       e.preventDefault();
                                          //       isAllowExchangeRef.current?.focus();
                                          //    }
                                          // },
                                          onKeyDown: (e) =>
                                             handleFocusMove(
                                                e,
                                                shouldSendCompanyidDaybook
                                                   ? companyRef
                                                   : mobile
                                                      ? isAllowExchangeRef
                                                      : savefinish,
                                                accountRef,
                                             ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {shouldSendCompanyidDaybook && (
                                    <GridItem className="seperator-width">
                                       {renderDynamicUiDropdown(
                                          'company',
                                          'Company',
                                          lastcompanyOptions,
                                          {
                                             value: row.compIds,
                                             onChange: handleCompanyChange,
                                             ref: companyRef,
                                             nextRef: mobile ? isAllowExchangeRef : savefinish,
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   mobile ? isAllowExchangeRef : savefinish,
                                                   isAskTypeOfSupplyRef,
                                                ),
                                          },
                                          {},
                                          textColor,
                                          false,
                                          'Select company',
                                          true,
                                          undefined,
                                          true,
                                       )}
                                    </GridItem>
                                 )}
                                 {mobile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isAllowExchange',
                                          'Ask Allow Of Exchange',
                                          {
                                             isChecked: row.isAllowExchange,
                                             onChange: handleSwitchChange('isAllowExchange'),
                                             ref: isAllowExchangeRef,
                                             // onKeyDown: (e) => {
                                             //    if (e.key === 'Enter' || e.key === 'Tab') {
                                             //       e.preventDefault();
                                             //       savefinish.current?.focus();
                                             //    }
                                             // },
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   isAllowGstRateRef,
                                                   shouldSendCompanyidDaybook ? companyRef : isAskTypeOfSupplyRef,
                                                ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 {company && company?.gstRegNo && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isAllowGstRate ',
                                          'Ask Allow Gst Rate',
                                          {
                                             isChecked: row.isAllowGstRate,
                                             onChange: handleSwitchChange('isAllowGstRate'),
                                             ref: isAllowGstRateRef,
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   savefinish,
                                                   mobile
                                                      ? isAllowExchangeRef
                                                      : shouldSendCompanyidDaybook
                                                         ? companyRef
                                                         : isAskTypeOfSupplyRef,
                                                ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                              </>
                           )}
                           {activeStep === 1 && (
                              <>
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'defaultaccountid',
                                       'Default Account',
                                       accountList,
                                       {
                                          value: row.defaultaccountid,
                                          onChange: (value) => handleInputChange('defaultaccountid', value),
                                          ref: defaultaccountRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                itemgroupsRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Default Account',
                                    )}
                                 </GridItem>
                                 <GridItem>
                                    {renderDynamicDropdown(
                                       'itemgroups',
                                       'Item Groups',
                                       itemgroupsoptions,
                                       {
                                          value: row.itemgroups,
                                          onChange: (e) => handleSelectChange('itemgroups', e),
                                          showCustomNoOptions: true,
                                          openfrom: 'itemgroups',
                                          ref: itemgroupsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                accountgroupsRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Default Account',
                                    )}
                                 </GridItem>

                                 <GridItem>
                                    {renderDynamicDropdown(
                                       'accountgroups',
                                       'Account Groups',
                                       accountgroupsoptions,
                                       {
                                          value: row.accountgroups,
                                          onChange: (e) => handleSelectChange('accountgroups', e),
                                          showCustomNoOptions: true,
                                          openfrom: 'ledger',
                                          ref: accountgroupsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                wareHouseRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Default Account',
                                    )}
                                 </GridItem>

                                 {warehouseWishStock && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {/* change */}
                                          {renderDynamicDropdown(
                                             'wareHouseId',
                                             'Ware House',
                                             warehouseList,
                                             {
                                                value: row.wareHouseId,
                                                onChange: (value) => handleInputChange('wareHouseId', value),
                                                showCustomNoOptions: true,
                                                openfrom: 'wareHouse',
                                                ref: wareHouseRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      wareHouseInRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Ware House',
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {/* change */}
                                          {renderDynamicDropdown(
                                             'warehouseInId',
                                             'Ware House in',
                                             WAREHOUSE_TYPE,
                                             {
                                                value: row.warehouseInId,
                                                onChange: (value) => handleInputChange('warehouseInId', value),
                                                ref: wareHouseInRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      getTransportDetailsRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Ware House',
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'getTransportDetails',
                                       'Transport Details',
                                       {
                                          isChecked: row.getTransportDetails,
                                          onChange: handleSwitchChange('getTransportDetails'),
                                          ref: getTransportDetailsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                getPaymentDetRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {Textile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'getWorkDetails',
                                          'Get Work Details',
                                          {
                                             isChecked: row.getWorkDetails,
                                             onChange: handleSwitchChange('getWorkDetails'),
                                             ref: getWorkDetailsRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   getOnlinePaymentDetailsRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'getOnlinePaymentDetails',
                                       'Get Online Payment Details',
                                       {
                                          isChecked: row.getOnlinePaymentDetails,
                                          onChange: handleSwitchChange('getOnlinePaymentDetails'),
                                          ref: getOnlinePaymentDetailsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                numOfLineItemsRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* Block Done*/}
                                    {renderDynamicDropdown(
                                       'actionIfLIReached',
                                       'Action If LI Reached',
                                       LINE_ITEM_REACHED,
                                       {
                                          value: row.actionIfLIReached,
                                          onChange: (value) => handleInputChange('actionIfLIReached', value),
                                          ref: actionIfLIReachedRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                defaultDateRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Action If LI Reached',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'defaultDate',
                                       'Default Date',
                                       {
                                          value: row.defaultDate,
                                          onChange: (e) => handleInputChange('defaultDate', e.target.value),
                                          ref: defaultDateRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                forceOrderedDateRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'date',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'allowZeroAmounts',
                                       'Allow Zero Amounts',
                                       {
                                          isChecked: row.allowZeroAmounts,
                                          onChange: handleSwitchChange('allowZeroAmounts'),
                                          ref: allowZeroAmountsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                allowEditLIAmountRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'allowEditLIAmount',
                                       'Allow Edit LI Amounts',
                                       {
                                          isChecked: row.allowEditLIAmount,
                                          onChange: handleSwitchChange('allowEditLIAmount'),
                                          ref: allowEditLIAmountRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                allowZeroQuantitiesRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'allowZeroQuantities',
                                       'Allow Zero Quantity',
                                       {
                                          isChecked: row.allowZeroQuantities,
                                          onChange: handleSwitchChange('allowZeroQuantities'),
                                          ref: allowZeroQuantitiesRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                allowIncreaseQtyRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {enablePurchaseOrder || enableSaleOrder ? (
                                    <>
                                       {/* Show "Allow Increase Qty" only when ORDER is ON */}
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'allowIncreaseQty',
                                             'Allow Increase Qty',
                                             {
                                                isChecked: row.allowIncreaseQty,
                                                onChange: handleSwitchChange('allowIncreaseQty'),
                                                ref: allowIncreaseQtyRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      allowChangePriceRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>

                                       {/* Show "Allow Change Price" when ORDER is ON */}
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'allowChangePrice',
                                             'Allow Change Price',
                                             {
                                                isChecked: row.allowChangePrice,
                                                onChange: handleSwitchChange('allowChangePrice'),
                                                ref: allowChangePriceRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      autoCallOutAdjRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 ) : enablePurchaseChallan || enableSaleChallan ? (
                                    <>
                                       {/* Show only "Allow Change Price" when CHALLAN is ON */}
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'allowChangePrice',
                                             'Allow Change Price',
                                             {
                                                isChecked: row.allowChangePrice,
                                                onChange: handleSwitchChange('allowChangePrice'),
                                                ref: allowChangePriceRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      autoCallOutAdjRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 ) : null}
                                 {(enablePurchaseOrder || enableSaleOrder) && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {/* Header Done*/}
                                          {renderDynamicDropdown(
                                             'orderFieldRegion',
                                             'Order Field Region',
                                             OrderFieldRegion,
                                             {
                                                value: row.orderFieldRegion,
                                                onChange: (value) => handleInputChange('orderFieldRegion', value),
                                                ref: orderFieldRegionRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      orderdaybookRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Order Field Region',
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'orderdaybookid',
                                             'Order Daybook',
                                             daybookList,
                                             {
                                                value: row.orderdaybookid,
                                                onChange: (value) => handleInputChange('orderdaybookid', value),
                                                showCustomNoOptions: true,
                                                openfrom: 'ledger',
                                                ref: orderdaybookRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      issueFieldRegionRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Order Daybook',
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 <GridItem className="seperator-width">
                                    {/* Header */}
                                    {renderDynamicDropdown(
                                       'issueFieldRegion',
                                       'Issue Field Region',
                                       OrderFieldRegion,
                                       {
                                          value: row.issueFieldRegion,
                                          onChange: (value) => handleInputChange('issueFieldRegion', value),
                                          ref: issueFieldRegionRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                issuedaybookRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Issue Field Region',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'issuedaybookid',
                                       'Issue Daybook',
                                       daybookList,
                                       {
                                          value: row.issuedaybookid,
                                          onChange: (value) => handleInputChange('issuedaybookid', value),
                                          ref: issuedaybookRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                challanFieldRegionRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Issue Daybook',
                                    )}
                                 </GridItem>
                                 {(enableSaleChallan || enablePurchaseChallan) && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {/* Header */}
                                          {renderDynamicDropdown(
                                             'challanFieldRegion',
                                             'Challan Field Region',
                                             OrderFieldRegion,
                                             {
                                                value: row.challanFieldRegion,
                                                onChange: (value) => handleInputChange('challanFieldRegion', value),
                                                ref: challanFieldRegionRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      challandaybookRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Challan Field Region',
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'challandaybookid',
                                             'Challan Daybook',
                                             daybookList,
                                             {
                                                value: row.challandaybookid,
                                                onChange: (value) => handleInputChange('challandaybookid', value),
                                                ref: challandaybookRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      getLineDetailRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Challan Daybook',
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 {Textile && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'getLineDetail',
                                             'Get Line Detail',
                                             {
                                                isChecked: row.getLineDetail,
                                                onChange: handleSwitchChange('getLineDetail'),
                                                ref: getLineDetailRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      allowAutoIssueRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>

                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'allowAutoIssue',
                                             'Allow Auto Issue',
                                             {
                                                isChecked: row.allowAutoIssue,
                                                onChange: handleSwitchChange('allowAutoIssue'),
                                                ref: allowAutoIssueRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      shouldAskSendSMSRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'shouldAskSendSMS',
                                       'Should Ask Send SMS',
                                       {
                                          isChecked: row.shouldAskSendSMS,
                                          onChange: handleSwitchChange('shouldAskSendSMS'),
                                          ref: shouldAskSendSMSRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                methodOfRoundTRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* Normal Done */}
                                    {renderDynamicDropdown(
                                       'methodOfRoundT',
                                       'Round Off (T)',
                                       METHOD_OF_ROUND_LI_TYPE,
                                       {
                                          value: row.methodOfRoundT,
                                          onChange: (value) => handleInputChange('methodOfRoundT', value),
                                          ref: methodOfRoundTRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                methodOfRoundLIRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Method of Round T',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* None Done */}
                                    {renderDynamicDropdown(
                                       'methodOfRoundLI',
                                       'Round Off (LI)',
                                       METHOD_OF_ROUND_LI_TYPE,
                                       {
                                          value: row.methodOfRoundLI || METHOD_OF_ROUND_LI_TYPE[1].id,
                                          onChange: (value) => handleInputChange('methodOfRoundLI', value),
                                          ref: methodOfRoundLIRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                autoRoundOffAtRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Method of Round LI',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* Total Done*/}
                                    {renderDynamicDropdown(
                                       'autoRoundOffAt',
                                       'Round off At',
                                       AUTO_ROUND_OFF_AT_TYPE,
                                       {
                                          value: row.autoRoundOffAt,
                                          onChange: (value) => handleInputChange('autoRoundOffAt', value),
                                          ref: autoRoundOffAtRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                requireDiscountLineItemRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Auto of Round T',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'requireDiscountLineItem',
                                       'Require Discount Line Item',
                                       {
                                          value: row.requireDiscountLineItem,
                                          onChange: (e) => handleInputChange('requireDiscountLineItem', e.target.value),
                                          ref: requireDiscountLineItemRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                isNotConsiderInStockRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'number',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isNotConsiderInStock',
                                       'Is Not Consider In Stock',
                                       {
                                          isChecked: row.isNotConsiderInStock,
                                          onChange: handleSwitchChange('isNotConsiderInStock'),
                                          ref: isNotConsiderInStockRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                isAskToAllowRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {mobile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isAskToAllow',
                                          'Ask Upload Document',
                                          {
                                             isChecked: row.isAskToAllow,
                                             onChange: handleSwitchChange('isAskToAllow'),
                                             ref: isAskToAllowRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   askPasswordOnDeleteRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'askPasswordOnDelete',
                                       'Ask Password On Delete',
                                       {
                                          isChecked: row.askPasswordOnDelete,
                                          onChange: handleSwitchChange('askPasswordOnDelete'),
                                          ref: askPasswordOnDeleteRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                savefinish.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isAskIncomeExpenses',
                                       'Ask Income Expenses',
                                       {
                                          isChecked: row.isAskIncomeExpenses,
                                          onChange: handleSwitchChange('isAskIncomeExpenses'),
                                          ref: isAskIncomeExpensesRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                dueDaysInputRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'dueDays',
                                       'dueDays',
                                       {
                                          value: row.dueDays,
                                          onChange: (e) => handleInputChange('dueDays', e.target.value),
                                          ref: dueDaysInputRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                savefinish.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'number',
                                       false,
                                    )}
                                 </GridItem>
                              </>
                           )}

                           {activeStep === 2 && (
                              <>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'titleMessage1',
                                       'Title Message 1',
                                       {
                                          value: row.titleMessage1,
                                          onChange: (e) => handleInputChange('titleMessage1', e.target.value),
                                          ref: titleMessage1Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                titleMessage2Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'titleMessage2',
                                       'Title Message 2',
                                       {
                                          value: row.titleMessage2,
                                          onChange: (e) => handleInputChange('titleMessage2', e.target.value),
                                          ref: titleMessage2Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                headerMessage1Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'headerMessage1',
                                       'Header Message 1',
                                       {
                                          value: row.headerMessage1,
                                          onChange: (e) => handleInputChange('headerMessage1', e.target.value),
                                          ref: headerMessage1Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                headerMessage2Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'headerMessage2',
                                       'Header Message 2',
                                       {
                                          value: row.headerMessage2,
                                          onChange: (e) => handleInputChange('headerMessage2', e.target.value),
                                          ref: headerMessage2Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                footerMessage1Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'footerMessage1',
                                       'Footer Message 1',
                                       {
                                          value: row.footerMessage1,
                                          onChange: (e) => handleInputChange('footerMessage1', e.target.value),
                                          ref: footerMessage1Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                footerMessage2Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'footerMessage2',
                                       'Footer Message 2',
                                       {
                                          value: row.footerMessage2,
                                          onChange: (e) => handleInputChange('footerMessage2', e.target.value),
                                          ref: footerMessage2Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                askBeforePrintRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'askBeforePrint',
                                       'Ask Before Print',
                                       {
                                          isChecked: row.askBeforePrint,
                                          onChange: handleSwitchChange('askBeforePrint'),
                                          ref: askBeforePrintRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                numOfCopiesRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* 1 Done*/}
                                    {DynamicInput(
                                       'numOfCopies',
                                       'No. Of Copies',
                                       {
                                          value: row.numOfCopies || 1,
                                          onChange: (e) => handleInputChange('numOfCopies', e.target.value),
                                          ref: numOfCopiesRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                onlinePrintingRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'number',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* True */}
                                    {renderSwitchControl(
                                       'onlinePrinting',
                                       'Online Printing',
                                       {
                                          isChecked: row.onlinePrinting,
                                          onChange: handleSwitchChange('onlinePrinting'),
                                          ref: onlinePrintingRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                ewayBillRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {applyGST && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'ewayBill',
                                             'E-way Bill',
                                             {
                                                isChecked: row.ewayBill,
                                                onChange: handleSwitchChange('ewayBill'),
                                                ref: ewayBillRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      ewayInvoiceRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'ewayInvoice',
                                             'E-Invoice',
                                             {
                                                isChecked: row.ewayInvoice,
                                                onChange: handleSwitchChange('ewayInvoice'),
                                                ref: ewayInvoiceRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      printingSettingsRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 <GridItem className="seperator-width">
                                    {/* Printing Settings Dropdown */}
                                    {renderDynamicDropdown(
                                       'printingSettings',
                                       'Printing Settings',
                                       PRINTING_SETTING_TYPE,
                                       {
                                          value: row.printingSettings,
                                          onChange: (value) => handleInputChange('printingSettings', value),
                                          ref: printingSettingsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                sendWhatsAppRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Printing Settings',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'sendWhatsApp',
                                       'Send WhatsApp',
                                       {
                                          isChecked: row.sendWhatsApp,
                                          onChange: handleSwitchChange('sendWhatsApp'),
                                          ref: sendWhatsAppRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                wpSettingsRef.current?.focus();
                                             }
                                          },
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* Printing Settings Dropdown */}
                                    {renderDynamicDropdown(
                                       'wpSettings',
                                       'WhatsApp Settings',
                                       PRINTING_SETTING_TYPE,
                                       {
                                          value: row.wpSettings,
                                          onChange: (value) => handleInputChange('wpSettings', value),
                                          ref: wpSettingsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                accImgTermsRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select WhatsApp Settings',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderTextareaControl(
                                       'accImgTerms',
                                       'Account Image Terms',
                                       {
                                          value: row.accImgTerms,
                                          onChange: (e) => handleInputChange('accImgTerms', e.target.value),
                                          ref: accImgTermsRef,
                                          onKeyDown: (e) => {
                                             if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
                                                e.preventDefault();
                                                accDocImgTermsRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderTextareaControl(
                                       'accDocImgTerms',
                                       'Account Doc Image Terms',
                                       {
                                          value: row.accDocImgTerms,
                                          onChange: (e) => handleInputChange('accDocImgTerms', e.target.value),
                                          ref: accDocImgTermsRef,
                                          onKeyDown: (e) => {
                                             if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
                                                e.preventDefault();
                                                termsNConditionsRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderTextareaControl(
                                       'termsNConditions',
                                       'Terms and Conditions',
                                       {
                                          value: row.termsNConditions,
                                          onChange: (e) => handleInputChange('termsNConditions', e.target.value),
                                          ref: termsNConditionsRef,
                                          onKeyDown: (e) => {
                                             if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
                                                e.preventDefault();
                                                savefinish.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                    )}
                                 </GridItem>
                              </>
                           )}

                           {activeStep === 3 && (
                              <>
                                 {['Bank'].includes(row.typeName) && (
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'accountNo',
                                          'Account No.',
                                          {
                                             value: row.accountNo,
                                             onChange: (e) => handleInputChange('accountNo', e.target.value),
                                             ref: accountNoRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   shortNameRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'shortName',
                                       'Short Name',
                                       {
                                          value: row.shortName,
                                          onChange: (e) => handleInputChange('shortName', e.target.value),
                                          ref: shortNameRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                printNameRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'printName',
                                       'Print Name',
                                       {
                                          value: row.printName,
                                          onChange: (e) => handleInputChange('printName', e.target.value),
                                          ref: printNameRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                legalNameRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'legalName',
                                       'Legal Name',
                                       {
                                          value: row.legalName,
                                          onChange: (e) => handleInputChange('legalName', e.target.value),
                                          ref: legalNameRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                notesRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'notes',
                                       'Notes',
                                       {
                                          value: row.notes,
                                          onChange: (e) => handleInputChange('notes', e.target.value),
                                          ref: notesRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                remarksRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'remarks',
                                       'Remarks',
                                       {
                                          value: row.remarks,
                                          onChange: (e) => handleInputChange('remarks', e.target.value),
                                          ref: remarksRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                updateRateInItemRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'updateRateInItem',
                                       'Update Rate In Item',
                                       {
                                          isChecked: row.updateRateInItem,
                                          onChange: handleSwitchChange('updateRateInItem'),
                                          ref: updateRateInItemRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                itemWiseLastRateRef.current?.focus();
                                             }
                                          },
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'itemWiseLastRate',
                                       'Item Wise Last Rate',
                                       {
                                          isChecked: row.itemWiseLastRate,
                                          onChange: handleSwitchChange('itemWiseLastRate'),
                                          ref: itemWiseLastRateRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                partyItemWiseLastRateRef.current?.focus();
                                             }
                                          },
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'partyItemWiseLastRate',
                                       'Party Item Wise Last Rate',
                                       {
                                          isChecked: row.partyItemWiseLastRate,

                                          onChange: handleSwitchChange('partyItemWiseLastRate'),
                                          ref: partyItemWiseLastRateRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                reverseCalcOnItemQtyRef.current?.focus();
                                             }
                                          },
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'reverseCalcOnItemQty',
                                       'Reverse Calc On Item Qty',
                                       {
                                          isChecked: row.reverseCalcOnItemQty,

                                          onChange: handleSwitchChange('reverseCalcOnItemQty'),
                                          ref: reverseCalcOnItemQtyRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                TDSApplyOnRef.current?.focus();
                                             }
                                          },
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'TDSApplyOn',
                                       'TDS Apply On',
                                       TDS_APPLY_ON,
                                       {
                                          value: row.TDSApplyOn,

                                          onChange: (value) => handleInputChange('TDSApplyOn', value),
                                          ref: TDSApplyOnRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                askToGenerateInvoiceRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'askOnlinePaymentDetails',
                                       'Ask Online Payment Details',
                                       {
                                          isChecked: row.askOnlinePaymentDetails,
                                          onChange: handleSwitchChange('askOnlinePaymentDetails'),
                                          ref: askOnlinePaymentDetailsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                isOldRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isOld',
                                       'Is Old',
                                       {
                                          isChecked: row.isOld,
                                          onChange: handleSwitchChange('isOld'),
                                          ref: isOldRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                purcherDaybookRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {(row.type === 5 || row.type === 19) && (
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'purchaseDaybookId',
                                          'Purchase Daybook',
                                          daybookData,
                                          {
                                             value: row.purchaseDaybookId,
                                             onChange: (value) => handleInputChange('purchaseDaybookId', value),
                                             ref: purcherDaybookRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   savefinish.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 {row.type === 11 && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'isGrayPurchase',
                                             'Is Gray Purchase',
                                             {
                                                isChecked: row.isGrayPurchase,
                                                onChange: handleSwitchChange('isGrayPurchase'),
                                                ref: isGrayPurchaseRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      purcherDaybookRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'isMillReceive',
                                             'Is Mill Receive',
                                             {
                                                isChecked: row.isMillReceive,
                                                onChange: handleSwitchChange('isMillReceive'),
                                                ref: isMillReceiveRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      purcherDaybookRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 {row.type === 19 && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isMillIssue',
                                          'Is Mill Issue',
                                          {
                                             isChecked: row.isMillIssue,
                                             onChange: handleSwitchChange('isMillIssue'),
                                             ref: isMillIssueRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   purcherDaybookRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 {Textile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isOtherJobWork',
                                          'Is Other JobWork',
                                          {
                                             isChecked: row.isOtherJobWork,
                                             onChange: handleSwitchChange('isOtherJobWork'),
                                             ref: isOtherJobWorkRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   purcherDaybookRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isAllowNotes',
                                       'Is Allow Notes',
                                       {
                                          isChecked: row.isAllowNotes,
                                          onChange: handleSwitchChange('isAllowNotes'),
                                          ref: isAllowNotesRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                purcherDaybookRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isAllowRemark',
                                       'Is Allow Remark',
                                       {
                                          isChecked: row.isAllowRemark,
                                          onChange: handleSwitchChange('isAllowRemark'),
                                          ref: isAllowRemarkRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                purcherDaybookRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem></GridItem>
                                 <div
                                    style={{
                                       width: '100%',
                                       gridColumn: '1 / -1',
                                       padding: '0',
                                       boxSizing: 'border-box',
                                    }}>
                                    <label
                                       style={{
                                          display: 'block',
                                          marginBottom: '12px',
                                          fontWeight: '600',
                                          fontSize: '16px',
                                          color: '#1f2937',
                                       }}>
                                       Custom Message Template
                                    </label>

                                    {/* Demo Formats Section - Working exactly like insert keys */}
                                    <div
                                       style={{
                                          marginBottom: '16px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          flexWrap: 'wrap',
                                          gap: '8px',
                                       }}>
                                       <span
                                          style={{
                                             fontWeight: '500',
                                             fontSize: '14px',
                                             color: '#6b7280',
                                             marginRight: '4px',
                                          }}>
                                          Demo Formats:
                                       </span>

                                       {/* Demo Format 1: Simple Receipt */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Your receipt #{docNo} for ₹{amount} has been processed on {txnDate}. Thank you!`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#dbeafe',
                                             border: '1px solid #93c5fd',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#1e40af',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#bfdbfe';
                                             e.currentTarget.style.borderColor = '#60a5fa';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#dbeafe';
                                             e.currentTarget.style.borderColor = '#93c5fd';
                                          }}
                                          title="Click to insert simple receipt format">
                                          Simple Receipt
                                       </button>

                                       {/* Demo Format 2: Detailed Transaction */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Transaction #{docNo}\nAmount: ₹{amount}\nDate: {txnDate}\nDaybook: {daybookName}\nCustomer: {customerName}\nNotes: {notes1}`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#dcfce7',
                                             border: '1px solid #86efac',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#166534',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#bbf7d0';
                                             e.currentTarget.style.borderColor = '#4ade80';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#dcfce7';
                                             e.currentTarget.style.borderColor = '#86efac';
                                          }}
                                          title="Click to insert detailed transaction format">
                                          Detailed Format
                                       </button>

                                       {/* Demo Format 3: Invoice Style */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Invoice #{docNo}\nCustomer: {customerName}\nCompany: {companyName}\nNet Amount: ₹{netAmount}\nGST: ₹{gstAmount}\nDate: {txnDate}`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#fef3c7',
                                             border: '1px solid #fcd34d',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#92400e',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#fde68a';
                                             e.currentTarget.style.borderColor = '#fbbf24';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#fef3c7';
                                             e.currentTarget.style.borderColor = '#fcd34d';
                                          }}
                                          title="Click to insert invoice format">
                                          Invoice Style
                                       </button>

                                       {/* Demo Format 4: Short SMS Style */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Hi {customerName}, your txn #{docNo} of ₹{amount} is completed on {txnDate}.`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#ede9fe',
                                             border: '1px solid #a78bfa',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#5b21b6',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#ddd6fe';
                                             e.currentTarget.style.borderColor = '#8b5cf6';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#ede9fe';
                                             e.currentTarget.style.borderColor = '#a78bfa';
                                          }}
                                          title="Click to insert SMS style format">
                                          SMS Style
                                       </button>

                                       {/* Demo Format 5: Professional Format */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Dear {customerName},\n\nThis is to confirm that your transaction #{docNo} for ₹{amount} has been successfully processed through {daybookName} on {txnDate}.\n\nThank you for your business.\n\nBest regards,\n{companyName}`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#fce7f3',
                                             border: '1px solid #f9a8d4',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#9d174d',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#fbcfe8';
                                             e.currentTarget.style.borderColor = '#f472b6';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#fce7f3';
                                             e.currentTarget.style.borderColor = '#f9a8d4';
                                          }}
                                          title="Click to insert professional format">
                                          Professional
                                       </button>
                                    </div>

                                    {/* Insert Keys Section */}
                                    <div
                                       style={{
                                          marginBottom: '16px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          flexWrap: 'wrap',
                                          gap: '8px',
                                       }}>
                                       <span
                                          style={{
                                             fontWeight: '500',
                                             fontSize: '14px',
                                             color: '#6b7280',
                                             marginRight: '4px',
                                          }}>
                                          Insert keys:
                                       </span>

                                       {(() => {
                                          // Get the current selected type from various possible sources
                                          const currentType = type || row?.type;
                                          const currentTypeName = row?.typeName;

                                          // Check if it's Cash or Bank
                                          const isCashOrBank = () => {
                                             // Check by code
                                             if (currentType === 'M' || currentType === 'N') return true;

                                             // Check by name
                                             if (currentTypeName === 'Cash' || currentTypeName === 'Bank') return true;

                                             // Check in TYPE array
                                             if (TYPE && currentType) {
                                                const typeItem = TYPE.find(
                                                   (item) =>
                                                      item.id === currentType ||
                                                      item.value === currentType ||
                                                      item.name === currentTypeName,
                                                );
                                                if (typeItem && (typeItem.code === 'M' || typeItem.code === 'N')) {
                                                   return true;
                                                }
                                             }

                                             return false;
                                          };

                                          const cashBankKeys = [
                                             'docNo',
                                             'amount',
                                             'daybookName',
                                             'txnDate',
                                             'chequeNo',
                                             'notes1',
                                             'notes2',
                                             'notes3',
                                             'notes4',
                                             'notes5',
                                             'customerName',
                                             'companyName',
                                             'gstAmount',
                                             'partyBillNo',
                                          ];

                                          const otherKeys = [
                                             'lrNo',
                                             'lrDate',
                                             'docNo',
                                             'notes',
                                             'partyNo',
                                             'customerName',
                                             'companyName',
                                             'daybookName',
                                             'gstAmount',
                                             'netAmount',
                                             'partyDate',
                                             'transportName',
                                             'vehicleName',
                                             'ewayBillNo',
                                             'ewayBillDate',
                                             'eInvoiceNo',
                                             'taxableAmount',
                                             'txnDate',
                                             'pendingAmt',
                                          ];

                                          const keysToShow = isCashOrBank() ? cashBankKeys : otherKeys;

                                          return keysToShow.map((key) => (
                                             <button
                                                key={key}
                                                type="button"
                                                onClick={() => insertKeyIntoMessage(key)}
                                                style={{
                                                   padding: '8px 14px',
                                                   backgroundColor: '#f3f4f6',
                                                   border: '1px solid #d1d5db',
                                                   borderRadius: '6px',
                                                   cursor: 'pointer',
                                                   fontSize: '13px',
                                                   fontWeight: '500',
                                                   color: '#374151',
                                                   transition: 'all 0.2s',
                                                   flexShrink: 0,
                                                }}
                                                onMouseEnter={(e) => {
                                                   e.currentTarget.style.backgroundColor = '#e5e7eb';
                                                   e.currentTarget.style.borderColor = '#9ca3af';
                                                }}
                                                onMouseLeave={(e) => {
                                                   e.currentTarget.style.backgroundColor = '#f3f4f6';
                                                   e.currentTarget.style.borderColor = '#d1d5db';
                                                }}>
                                                {key}
                                             </button>
                                          ));
                                       })()}
                                    </div>

                                    <div style={{ position: 'relative', width: '100%' }}>
                                       {/* Highlighted backdrop */}
                                       <div
                                          ref={highlightRef}
                                          style={{
                                             position: 'absolute',
                                             top: 0,
                                             left: 0,
                                             right: 0,
                                             bottom: 0,
                                             padding: '14px',
                                             fontSize: '14px',
                                             lineHeight: '1.6',
                                             fontFamily:
                                                'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                                             whiteSpace: 'pre-wrap',
                                             wordBreak: 'break-word',
                                             overflowWrap: 'break-word',
                                             color: '#1f2937',
                                             backgroundColor: 'transparent',
                                             border: '2px solid transparent',
                                             borderRadius: '8px',
                                             boxSizing: 'border-box',
                                             pointerEvents: 'none',
                                          }}>
                                          {row.customTemp ? (
                                             renderColoredText(row.customTemp)
                                          ) : (
                                             <span style={{ color: '#9ca3af' }}>
                                                Type your message here. Click keys above to insert variables like{' '}
                                                {'{docNo}'}, {'{amount}'}
                                             </span>
                                          )}
                                       </div>

                                       <textarea
                                          ref={textareaRef}
                                          value={row.customTemp || ''}
                                          onChange={handleCustomTempChange}
                                          onScroll={handleTextareaScroll}
                                          placeholder=""
                                          spellCheck={false}
                                          autoComplete="off"
                                          autoCorrect="off"
                                          autoCapitalize="off"
                                          style={{
                                             position: 'relative',
                                             width: '100%',
                                             minHeight: '150px',
                                             padding: '14px',
                                             border: `2px solid ${errors.customTemp ? '#ef4444' : '#d1d5db'}`,
                                             borderRadius: '8px',
                                             fontSize: '14px',
                                             lineHeight: '1.6',
                                             fontFamily:
                                                'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                                             resize: 'vertical',
                                             backgroundColor: 'transparent',
                                             color: 'transparent',
                                             caretColor: '#1f2937',
                                             boxSizing: 'border-box',
                                             outline: 'none',
                                             WebkitTextFillColor: 'transparent',
                                             overflow: 'auto',
                                             maxHeight: '400px',
                                          }}
                                       />
                                    </div>
                                    {errors.customTemp && (
                                       <div
                                          style={{
                                             color: '#ef4444',
                                             fontSize: '13px',
                                             marginTop: '10px',
                                             padding: '8px 12px',
                                             backgroundColor: '#fef2f2',
                                             border: '1px solid #fecaca',
                                             borderRadius: '6px',
                                          }}>
                                          {errors.customTemp}
                                       </div>
                                    )}
                                    {error && (
                                       <div
                                          style={{
                                             color: '#ef4444',
                                             fontSize: '13px',
                                             marginTop: '10px',
                                             padding: '8px 12px',
                                             backgroundColor: '#fef2f2',
                                             border: '1px solid #fecaca',
                                             borderRadius: '6px',
                                          }}>
                                          {error}
                                       </div>
                                    )}
                                 </div>
                              </>
                           )}
                        </Grid>
                     </Box>
                  </GridItem>
               </Grid>
            </ModalBody>

            <ModalFooter
               borderTop="1px solid"
               borderColor={isDark ? 'gray.700' : 'gray.200'}
               bg={isDark ? 'gray.900' : 'gray.50'}
               borderBottomRadius="24px"
               p={2}
               gap={3}>
               {activeStep > 0 && (
                  <Button
                     onClick={handlePrevious}
                     variant="ghost"
                     colorScheme="purple"
                     size="lg"
                     fontWeight="600"
                     _hover={{ bg: isDark ? 'purple.900' : 'purple.50' }}
                     _focus={{ boxShadow: '0 0 0 3px rgba(139, 92, 246, 0.3)' }}>
                     Previous
                  </Button>
               )}
               {activeStep < 3 && (
                  <Button
                     onClick={handleNext}
                     variant="ghost"
                     colorScheme="purple"
                     size="lg"
                     fontWeight="600"
                     _hover={{ bg: isDark ? 'purple.900' : 'purple.50' }}
                     _focus={{ boxShadow: '0 0 0 3px rgba(139, 92, 246, 0.3)' }}>
                     Next
                  </Button>
               )}

               {!isEditMode && saveandcontinue === true && (
                  <Button
                     onClick={handlesavecontinue}
                     isLoading={isLoading}
                     disabled={isLoading}
                     bg={isDark ? 'blue.600' : 'blue.500'}
                     color="white"
                     size="lg"
                     fontWeight="600"
                     _hover={{ bg: isDark ? 'blue.700' : 'blue.600' }}
                     _active={{ bg: isDark ? 'blue.800' : 'blue.700' }}
                     _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.3)' }}
                     boxShadow="0 4px 12px rgba(59, 130, 246, 0.3)">
                     Save & Continue
                  </Button>
               )}
               <Button
                  onClick={handleSave}
                  isLoading={isLoading}
                  disabled={isLoading}
                  ref={savefinish}
                  bg={
                     isDark
                        ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                        : 'linear-gradient(135deg, #34d399 0%, #10b981 100%)'
                  }
                  color="white"
                  size="lg"
                  fontWeight="600"
                  _hover={{
                     transform: 'translateY(-2px)',
                     boxShadow: '0 8px 20px rgba(16, 185, 129, 0.4)',
                  }}
                  _active={{ transform: 'translateY(0)' }}
                  _focus={{ boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.3)' }}
                  boxShadow="0 4px 12px rgba(16, 185, 129, 0.3)"
                  transition="all 0.3s">
                  Save & Finish
               </Button>

               <Button
                  variant="ghost"
                  onClick={handleCansel}
                  size="lg"
                  fontWeight="600"
                  color={isDark ? 'gray.400' : 'gray.600'}
                  _hover={{ bg: isDark ? 'gray.800' : 'gray.100' }}
                  _focus={{ boxShadow: '0 0 0 3px rgba(107, 114, 128, 0.3)' }}>
                  Cancel
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default DaybookForm;
